/* ******** TAG PREVIEW INTEGRATION ******* */
// ****************************************
// ****************************************
// ****************************************





/* Prevents special characters, emoji, etc from being entered in tag input fields. This should be everything on a US keyboard except for pipe and backslash  */
$(document).ready(function() {
    $(".max").keydown(function (e) {
        // Allow: backspace, delete, tab, escape, enter and .
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
             // Allow: Ctrl+A
            (e.keyCode == 65 && e.ctrlKey === true)) 
             // Allow: home, end, left, right
			 {
                 // let it happen, don't do anything
                 return;
                 
        }
        // Ensure that it is a number and stop the keypress
        if ((e.keyCode > 224) || (e.keyCode == 220) || (e.keyCode == 0)) {
            e.preventDefault();
        }
    });


    // The following prevents pasting emojis
    $(".max").on("paste", function(e) {
        // Allow: backspace, delete, tab, escape, enter and .
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
             // Allow: Ctrl+A
            (e.keyCode == 65 && e.ctrlKey === true)) 
             // Allow: home, end, left, right
			 {
                 // let it happen, don't do anything
                 return;
                 
        }
        // Ensure that it is a number and stop the keypress
        if ((e.keyCode > 224) || (e.keyCode == 220) || (e.keyCode == 0)) {
            e.preventDefault();
        }

        // The lines below are the important part of the code; the above is copied for good measure.
        var pasteData = e.originalEvent.clipboardData.getData('text');
        const withEmojis = /\p{Extended_Pictographic}/u;
        if (withEmojis.test(e.originalEvent.clipboardData.getData('text'))) {
          e.preventDefault();
        } 

        // pasteData.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '');
        //return;

    });
    
}); 

/* BIG FUNCTION THAT DOES BASICALLY EVERYTHING. Called twice at the end of file. */
    
function tagPreviewCompleteCircle(a, b, c, d, e, f, g, h, i, j, k, l){
    
  var text_max = 14;
  /* CHANGE keyup TO keypress IF YOU WANT THE VISUAL AUTO-DELETE TO STOP HAPPENING. DOING SO WILL INTRODUCE ANOTHER ISSUE, WHICH IS THAT YOU CAN NO LONGER TYPE NEW CHARACTERS WHEN ALL CURRENT ONES ARE HIGHLIGHTED */

    /* Turning function arguments into variables */
    var ta1 = arguments[0];
    var ta2 = arguments[1];
    var ta3 = arguments[2];
    var ta4 = arguments[3];
    var tline1 = arguments[4];
    var tline2 = arguments[5]
    var tline3 = arguments[6];
    var tline4 = arguments[7];
    var taf1 = arguments[8];
    var taf2 = arguments[9];
    var taf3 = arguments[10];
    var taf4 = arguments[11];
  
    /* Removing event listeners from other functions */  
    document.getElementById(ta1).removeEventListener('keyup', function(event) {
      inputBox1.onkeyup();
      inputBox2.onkeyup();
      inputBox3.onkeyup();
    });
    document.getElementById(ta2).removeEventListener('keyup', function(event) {
      inputBox1.onkeyup();
      inputBox2.onkeyup();
      inputBox3.onkeyup();
    });
    document.getElementById(ta3).removeEventListener('keyup', function(event) {
      inputBox1.onkeyup();
      inputBox2.onkeyup();
      inputBox3.onkeyup();
    });
    document.getElementById(ta1).removeEventListener('keyup', function(event) {
      inputBox1.onkeyup();
      inputBox2.onkeyup();
      inputBox3.onkeyup();
      inputBox4.onkeyup();
    });
    document.getElementById(ta2).removeEventListener('keyup', function(event) {
      inputBox1.onkeyup();
      inputBox2.onkeyup();
      inputBox3.onkeyup();
      inputBox4.onkeyup();
    });
    document.getElementById(ta3).removeEventListener('keyup', function(event) {
      inputBox1.onkeyup();
      inputBox2.onkeyup();
      inputBox3.onkeyup();
      inputBox4.onkeyup();
    });
    document.getElementById(ta4).removeEventListener('keyup', function(event) {
      inputBox1.onkeyup();
      inputBox2.onkeyup();
      inputBox3.onkeyup();
      inputBox4.onkeyup();
    });
  
  /* Set default state of characters remaining text */    
  var tl1 = $('\#' + ta1).val().length;
  var tl2 = $('\#' + ta2).val().length;
  var tl3 = $('\#' + ta2).val().length;
  var tl4 = $('\#' + ta2).val().length;
  $('\#' + taf1).html(tl1 + ' / ' + text_max);
  $('\#' + taf2).html(tl2 + ' / ' + text_max);
  $('\#' + taf3).html(tl3 + ' / ' + text_max);
  $('\#' + taf4).html(tl4 + ' / ' + text_max);

  /* Function to alter characters remaining dynamically - Input 1 */
  $('\#' + ta1).keyup(function() {    
    var text_length = $('\#' + ta1).val().length;
    var text_remaining = text_max - text_length;

    $('\#' + taf1).html(text_length + ' / 14');
    if (text_remaining < 1) {
      document.getElementById(taf1).style.color = "#ff0000";
      document.getElementById(taf1).append('  [Legibility concern]');
    } else if (text_remaining == 1) {
      document.getElementById(taf1).style.color = "#ed8326";
      document.getElementById(taf1).append('  [Legibility concern]');
    } else {
      document.getElementById(taf1).style.color = "blue";
    }
  });  
  /* Function to alter characters remaining dynamically - Input 2 */
  $('\#' + ta2).keyup(function() {
    var text_length = $('\#' + ta2).val().length;
    var text_remaining = text_max - text_length;

    $('\#' + taf2).html(text_length + ' / 14');
    if (text_remaining < 1) {
      document.getElementById(taf2).style.color = "#ff0000";
      document.getElementById(taf2).append('  [Legibility concern]');
    } else if (text_remaining == 1) {
      document.getElementById(taf2).style.color = "#ed8326";
      document.getElementById(taf2).append('  [Legibility concern]');
    } else {
      document.getElementById(taf2).style.color = "blue";
    }
  });
  /* Function to alter characters remaining dynamically - Input 3 */
  $('\#' + ta3).keyup(function() {
    var text_length = $('\#' + ta3).val().length;
    var text_remaining = text_max - text_length;

    $('\#' + taf3).html(text_length + ' / 14');
    if (text_remaining < 1) {
      document.getElementById(taf3).style.color = "#ff0000";
      document.getElementById(taf3).append('  [Legibility concern]');
    } else if (text_remaining == 1) {
      document.getElementById(taf3).style.color = "#ed8326";
      document.getElementById(taf3).append('  [Legibility concern]');
    } else {
      document.getElementById(taf3).style.color = "blue";
    }
  });
  /* Function to alter characters remaining dynamically - Input 4 */
  $('\#' + ta4).keyup(function() {
    var text_length = $('\#' + ta4).val().length;
    var text_remaining = text_max - text_length;

    $('\#' + taf4).html(text_length + ' / 14');
    if (text_remaining < 1) {
      document.getElementById(taf4).style.color = "#ff0000";
      document.getElementById(taf4).append('  [Legibility concern]');
    } else if (text_remaining == 1) {
      document.getElementById(taf4).style.color = "#ed8326";
      document.getElementById(taf4).append('  [Legibility concern]');
    } else {
      document.getElementById(taf4).style.color = "blue";
    }
  });
  
    
  /* Variables to be used in character size functions as well as starting values */
  var lineOneSize = 40;
  var lineTwoSize = 40;
  var lineThreeSize = 40;
  var lineFourSize = 40;

  var lineOneCharSpacing = 2;
  var lineTwoCharSpacing = 2;
  var lineThreeCharSpacing = 2;
  var lineFourCharSpacing = 2;

  /* Shortcut variables for input boxes */
  var inputBox1 = document.getElementById(ta1);
  var inputBox2 = document.getElementById(ta2);
  var inputBox3 = document.getElementById(ta3);
  var inputBox4 = document.getElementById(ta4); 
    
  /* Text sizing function for input box 1 */
  inputBox1.onkeyup = function() {
    /* Condition 2: If there are more than 5 characters, change font size */
    if (document.getElementById(ta1).value.length <= 5) {
      lineOneSize = 40;
      lineOneCharSpacing = 2;
    }
    if (document.getElementById(ta1).value.length > 5) {
      lineOneSize = 40;
      lineOneCharSpacing = 1.6;
    }
    if (document.getElementById(ta1).value.length > 6) {
      lineOneSize = 32.5;
      lineOneCharSpacing = 1.4;
    }
    if (document.getElementById(ta1).value.length > 7) {
      lineOneSize = 30;
      lineOneCharSpacing = 1.2;
    }
    if (document.getElementById(ta1).value.length > 8) {
      lineOneSize = 27.5;
      lineOneCharSpacing = 1;
    }
    if (document.getElementById(ta1).value.length > 9) {
      lineOneSize = 25;
      lineOneCharSpacing = 0.8;
    }
    if (document.getElementById(ta1).value.length > 10) {
      lineOneSize = 23;
      lineOneCharSpacing = 0.6;
    }
    if (document.getElementById(ta1).value.length > 11) {
      lineOneSize = 22;
      lineOneCharSpacing = 0.4;
    }
    if (document.getElementById(ta1).value.length > 12) {
      lineOneSize = 21;
      lineOneCharSpacing = 0.2;
    }
    if (document.getElementById(ta1).value.length > 13) {
      lineOneSize = 20;
      lineOneCharSpacing = 0;
    }
    /* Condition 1: if there is text in other lines, change the min size of line 1 */
    var lineNumberMode = 0;
    if (document.getElementById(ta2).value.length >= 1 || document.getElementById(ta3).value.length >= 1 || document.getElementById(ta4).value.length >= 1) {
      lineNumberMode = 1;
    }
    if (document.getElementById(ta2).value.length >= 1 && (document.getElementById(ta3).value.length >= 1 || document.getElementById(ta4).value.length >= 1)) {
      lineNumberMode = 2;
    }
    if (document.getElementById(ta3).value.length >= 1 && (document.getElementById(ta2).value.length >= 1 || document.getElementById(ta4).value.length >= 1)) {
      lineNumberMode = 2;
    }
    if (document.getElementById(ta3).value.length >= 1 && document.getElementById(ta2).value.length >= 1 && document.getElementById(ta4).value.length >= 1) {
      lineNumberMode = 3;
    }
    var lineNumberFactor = 1;
    if (lineNumberMode == 0) {
      lineNumberFactor = 1.2;
    }
    if (lineNumberMode == 1) {
      lineNumberFactor = 1.16;
    }
    if (lineNumberMode == 2) {
      lineNumberFactor = 1.13;
    }
    if (lineNumberMode == 3) {
      lineNumberFactor = 0.96;
    }
    /* Original lineNumberFactors: 1, .9, .7, .55 */
    document.getElementById(tline1).innerHTML = inputBox1.value;
    if (lineOneSize * lineNumberFactor < 23) {
      lineOneSize = 23/lineNumberFactor;
    }
    if (lineNumberMode === 1 && lineOneSize*lineNumberFactor > 42)
        {lineOneSize = 42/lineNumberFactor;
    }
    if (lineNumberMode === 2 && lineOneSize*lineNumberFactor > 31)
        {lineOneSize = 31/lineNumberFactor;
    }
    if (lineNumberMode === 3 && lineOneSize*lineNumberFactor > 26)
        {lineOneSize = 26/lineNumberFactor;
    }
    document.getElementById(tline1).style.fontSize = lineOneSize * lineNumberFactor + "px";
    document.getElementById(tline1).style.letterSpacing = lineOneCharSpacing + "px";
    if (lineNumberMode == 1) {document.getElementById(tline1).style.lineHeight = "110%";}
    if (lineNumberMode == 2) {document.getElementById(tline1).style.lineHeight = "105%";}
    if (lineNumberMode == 3) {document.getElementById(tline1).style.lineHeight = "90%";}
  }

 

  /* Text sizing function for input box 2 */
  inputBox2.onkeyup = function() {
    /* Condition 2: If there are more than 5 characters, change font size */
    if (document.getElementById(ta2).value.length <= 5) {
      lineTwoSize = 40;
      lineTwoCharSpacing = 2;
    }
    if (document.getElementById(ta2).value.length > 5) {
      lineTwoSize = 40;
      lineTwoCharSpacing = 1.6;
    }
    if (document.getElementById(ta2).value.length > 6) {
      lineTwoSize = 32.5;
      lineTwoCharSpacing = 1.4;
    }
    if (document.getElementById(ta2).value.length > 7) {
      lineTwoSize = 30;
      lineTwoCharSpacing = 1.2;
    }
    if (document.getElementById(ta2).value.length > 8) {
      lineTwoSize = 27.5;
      lineTwoCharSpacing = 1.0;
    }
    if (document.getElementById(ta2).value.length > 9) {
      lineTwoSize = 25;
      lineTwoCharSpacing = 0.8;
    }
    if (document.getElementById(ta2).value.length > 10) {
      lineTwoSize = 23;
      lineTwoCharSpacing = 0.6;
    }
    if (document.getElementById(ta2).value.length > 11) {
      lineTwoSize = 22;
      lineTwoCharSpacing = 0.4;
    }
    if (document.getElementById(ta2).value.length > 12) {
      lineTwoSize = 21;
      lineTwoCharSpacing = 0.2;
    }
    if (document.getElementById(ta2).value.length > 13) {
      lineTwoSize = 20;
      lineTwoCharSpacing = 0;
    }
    /* Condition 1: if there is text in other lines, change the min size of line 1 */
    var lineNumberMode = 0;
    if (document.getElementById(ta1).value.length >= 1 || document.getElementById(ta3).value.length >= 1 || document.getElementById(ta4).value.length >= 1) {
      lineNumberMode = 1;
    }
    if (document.getElementById(ta1).value.length >= 1 && (document.getElementById(ta3).value.length >= 1 || document.getElementById(ta4).value.length >= 1)) {
      lineNumberMode = 2;
    }
    if (document.getElementById(ta3).value.length >= 1 && (document.getElementById(ta1).value.length >= 1 || document.getElementById(ta4).value.length >= 1)) {
      lineNumberMode = 2;
    }
    if (document.getElementById(ta3).value.length >= 1 && document.getElementById(ta1).value.length >= 1 && document.getElementById(ta4).value.length >= 1) {
      lineNumberMode = 3;
    }
    var lineNumberFactor = 1;
    if (lineNumberMode == 0) {
      lineNumberFactor = 1.2;
    }
    if (lineNumberMode == 1) {
      lineNumberFactor = 1.16;
    }
    if (lineNumberMode == 2) {
      lineNumberFactor = 1.13;
    }
    if (lineNumberMode == 3) {
      lineNumberFactor = 0.96;
    }
    document.getElementById(tline2).innerHTML = inputBox2.value;
    inputBox1.onkeyup();
    if (document.getElementById(ta1).value.length >= 1 && lineTwoSize * lineNumberFactor > lineOneSize * lineNumberFactor) {
      lineTwoSize = lineOneSize;
    }
    if (lineTwoSize * lineNumberFactor < 23) {
      lineTwoSize = 23/lineNumberFactor;
    }
    if (lineNumberMode === 1 && lineTwoSize*lineNumberFactor > 42)
        {lineTwoSize = 42/lineNumberFactor;
    }
    if (lineNumberMode === 2 && lineTwoSize*lineNumberFactor > 31)
        {lineTwoSize = 31/lineNumberFactor;
    }
    if (lineNumberMode === 3 && lineTwoSize*lineNumberFactor > 26)
        {lineTwoSize = 26/lineNumberFactor;
    }
    document.getElementById(tline2).style.fontSize = lineTwoSize * lineNumberFactor + "px";
    document.getElementById(tline2).style.letterSpacing = lineTwoCharSpacing + "px";
    if (lineNumberMode == 1) {document.getElementById(tline2).style.lineHeight = "110%";}
    if (lineNumberMode == 2) {document.getElementById(tline2).style.lineHeight = "105%";}
    if (lineNumberMode == 3) {document.getElementById(tline2).style.lineHeight = "90%";}
  }


    
  /* Text sizing function for input box 3 */
  inputBox3.onkeyup = function() {
    /* Condition 2: If there are more than 5 characters, change font size */
    if (document.getElementById(ta3).value.length <= 5) {
      lineThreeSize = 40;
      lineThreeCharSpacing = 2;
    }
    if (document.getElementById(ta3).value.length > 5) {
      lineThreeSize = 40;
      lineThreeCharSpacing = 1.6;
    }
    if (document.getElementById(ta3).value.length > 6) {
      lineThreeSize = 32.5;
      lineThreeCharSpacing = 1.4;
    }
    if (document.getElementById(ta3).value.length > 7) {
      lineThreeSize = 30;
      lineThreeCharSpacing = 1.2;
    }
    if (document.getElementById(ta3).value.length > 8) {
      lineThreeSize = 27.5;
      lineThreeCharSpacing = 1.0;
    }
    if (document.getElementById(ta3).value.length > 9) {
      lineThreeSize = 25;
      lineThreeCharSpacing = 0.8;
    }
    if (document.getElementById(ta3).value.length > 10) {
      lineThreeSize = 23;
      lineThreeCharSpacing = 0.6;
    }
    if (document.getElementById(ta3).value.length > 11) {
      lineThreeSize = 22;
      lineThreeCharSpacing = 0.4;
    }
    if (document.getElementById(ta3).value.length > 12) {
      lineThreeSize = 21;
      lineThreeCharSpacing = 0.2;
    }
    if (document.getElementById(ta3).value.length > 13) {
      lineThreeSize = 20;
      lineThreeCharSpacing = 0;
    }
    /* Condition 1: if there is text in other lines, change the min size of line 1 */
    var lineNumberMode = 0;
    if (document.getElementById(ta1).value.length >= 1 || document.getElementById(ta2).value.length >= 1 || document.getElementById(ta4).value.length >= 1) {
      lineNumberMode = 1;
    }
    if (document.getElementById(ta1).value.length >= 1 && (document.getElementById(ta2).value.length >= 1 || document.getElementById(ta4).value.length >= 1)) {
      lineNumberMode = 2;
    }
    if (document.getElementById(ta2).value.length >= 1 && (document.getElementById(ta1).value.length >= 1 || document.getElementById(ta4).value.length >= 1)) {
      lineNumberMode = 2;
    }
    if (document.getElementById(ta1).value.length >= 1 && document.getElementById(ta2).value.length >= 1 && document.getElementById(ta4).value.length >= 1) {
      lineNumberMode = 3;
    }
    var lineNumberFactor = 1;
    if (lineNumberMode == 0) {
      lineNumberFactor = 1.2;
    }
    if (lineNumberMode == 1) {
      lineNumberFactor = 1.16;
    }
    if (lineNumberMode == 2) {
      lineNumberFactor = 1.13;
    }
    if (lineNumberMode == 3) {
      lineNumberFactor = 0.96;
    }
    document.getElementById(tline3).innerHTML = inputBox3.value;
    inputBox1.onkeyup();
    if (document.getElementById(ta1).value.length >= 1 && lineThreeSize * lineNumberFactor > lineOneSize * lineNumberFactor) {
      lineThreeSize = lineOneSize;
    }
    inputBox2.onkeyup();
    if (document.getElementById(ta2).value.length >= 1 && lineThreeSize * lineNumberFactor > lineTwoSize * lineNumberFactor) {
      lineThreeSize = lineTwoSize;
    }
    if (lineThreeSize * lineNumberFactor < 23) {
      lineThreeSize = 23/lineNumberFactor;
    }
    if (lineNumberMode === 1 && lineThreeSize*lineNumberFactor > 42)
        {lineThreeSize = 42/lineNumberFactor;
    }
    if (lineNumberMode === 2 && lineThreeSize*lineNumberFactor > 31)
        {lineThreeSize = 31/lineNumberFactor;
    }
    if (lineNumberMode === 3 && lineThreeSize*lineNumberFactor > 26)
        {lineThreeSize = 26/lineNumberFactor;
    }
    document.getElementById(tline3).style.fontSize = lineThreeSize * lineNumberFactor + "px";
    document.getElementById(tline3).style.letterSpacing = lineThreeCharSpacing + "px";
    if (document.getElementById(ta2).value.length > 0 && document.getElementById(ta3).value.length > document.getElementById(ta2).value.length) {document.getElementById(tline2).style.fontSize = lineThreeSize * lineNumberFactor + "px";}
    if (document.getElementById(ta2).value.length > 0 && document.getElementById(ta3).value.length > document.getElementById(ta2).value.length) {document.getElementById(tline2).style.letterSpacing = lineThreeCharSpacing + "px";}
    if (lineNumberMode == 1) {document.getElementById(tline3).style.lineHeight = "110%";}
    if (lineNumberMode == 2) {document.getElementById(tline3).style.lineHeight = "105%";}
    if (lineNumberMode == 3) {document.getElementById(tline3).style.lineHeight = "90%";}
  }


  /* Text sizing function for input box 4 */
  inputBox4.onkeyup = function() {
    /* Condition 2: If there are more than 5 characters, change font size */
    if (document.getElementById(ta4).value.length <= 5) {
      lineFourSize = 40;
      lineFourCharSpacing = 2;
    }
    if (document.getElementById(ta4).value.length > 5) {
      lineFourSize = 40;
      lineFourCharSpacing = 1.6;
    }
    if (document.getElementById(ta4).value.length > 6) {
      lineFourSize = 32.5;
      lineFourCharSpacing = 1.4;
    }
    if (document.getElementById(ta4).value.length > 7) {
      lineFourSize = 30;
      lineFourCharSpacing = 1.2;
    }
    if (document.getElementById(ta4).value.length > 8) {
      lineFourSize = 27.5;
      lineFourCharSpacing = 1.0;
    }
    if (document.getElementById(ta4).value.length > 9) {
      lineFourSize = 25;
      lineFourCharSpacing = 0.8;
    }
    if (document.getElementById(ta4).value.length > 10) {
      lineFourSize = 23;
      lineFourCharSpacing = 0.6;
    }
    if (document.getElementById(ta4).value.length > 11) {
      lineFourSize = 22;
      lineFourCharSpacing = 0.4;
    }
    if (document.getElementById(ta4).value.length > 12) {
      lineFourSize = 21;
      lineFourCharSpacing = 0.2;
    }
    if (document.getElementById(ta4).value.length > 13) {
      lineFourSize = 20;
      lineFourCharSpacing = 0;
    }
    /* Condition 1: if there is text in other lines, change the min size of line 1 */
    var lineNumberMode = 0;
    if (document.getElementById(ta1).value.length >= 1 || document.getElementById(ta2).value.length >= 1 || document.getElementById(ta3).value.length >= 1) {
      lineNumberMode = 1;
    }
    if (document.getElementById(ta1).value.length >= 1 && (document.getElementById(ta2).value.length >= 1 || document.getElementById(ta3).value.length >= 1)) {
      lineNumberMode = 2;
    }
    if (document.getElementById(ta2).value.length >= 1 && (document.getElementById(ta1).value.length >= 1 || document.getElementById(ta3).value.length >= 1)) {
      lineNumberMode = 2;
    }
    if (document.getElementById(ta1).value.length >= 1 && document.getElementById(ta2).value.length >= 1 && document.getElementById(ta3).value.length >= 1) {
      lineNumberMode = 3;
    }
    var lineNumberFactor = 1;
    if (lineNumberMode == 0) {
      lineNumberFactor = 1.2;
    }
    if (lineNumberMode == 1) {
      lineNumberFactor = 1.16;
    }
    if (lineNumberMode == 2) {
      lineNumberFactor = 1.13;
    }
    if (lineNumberMode == 3) {
      lineNumberFactor = 0.96;
    }
    document.getElementById(tline4).innerHTML = inputBox4.value;
    inputBox1.onkeyup();
    if (document.getElementById(ta1).value.length >= 1 && lineFourSize * lineNumberFactor > lineOneSize * lineNumberFactor) {
      lineFourSize = lineOneSize;
    }
    inputBox2.onkeyup();
    if (document.getElementById(ta2).value.length >= 1 && lineFourSize * lineNumberFactor > lineTwoSize * lineNumberFactor) {
      lineFourSize = lineTwoSize;
    }
    inputBox3.onkeyup();
    if (document.getElementById(ta3).value.length >= 1 && lineFourSize * lineNumberFactor > lineThreeSize * lineNumberFactor) {
      lineFourSize = lineThreeSize;
    }
    if (lineFourSize * lineNumberFactor < 23) {
      lineFourSize = 23/lineNumberFactor;
    }
    if (lineNumberMode === 1 && lineFourSize*lineNumberFactor > 42)
        {lineFourSize = 42/lineNumberFactor;
    }
    if (lineNumberMode === 2 && lineFourSize*lineNumberFactor > 31)
        {lineFourSize = 31/lineNumberFactor;
    }
    if (lineNumberMode === 3 && lineFourSize*lineNumberFactor > 26)
        {lineFourSize = 26/lineNumberFactor;
    }
    document.getElementById(tline4).style.fontSize = lineFourSize * lineNumberFactor + "px";
    document.getElementById(tline4).style.letterSpacing = lineFourCharSpacing + "px";
    if (document.getElementById(ta3).value.length > 0 && document.getElementById(ta4).value.length > document.getElementById(ta3).value.length) {
      	document.getElementById(tline3).style.fontSize = lineFourSize * lineNumberFactor + "px";
      	document.getElementById(tline2).style.fontSize = lineFourSize * lineNumberFactor + "px";
    }
    if (document.getElementById(ta3).value.length > 0 && document.getElementById(ta4).value.length > document.getElementById(ta3).value.length) {
      	document.getElementById(tline3).style.letterSpacing = lineFourCharSpacing + "px";
      	document.getElementById(tline2).style.letterSpacing = lineFourCharSpacing + "px";
    }
    if (lineNumberMode == 1) {document.getElementById(tline4).style.lineHeight = "110%";}
    if (lineNumberMode == 2) {document.getElementById(tline4).style.lineHeight = "105%";}
    if (lineNumberMode == 3) {document.getElementById(tline4).style.lineHeight = "90%";}
  }

  
  /* Adding event listeners to call all four text sizing functions when a key is pressed in any of the four input boxes. This is necessary as the size of one line is dynamically calculated by the size of the other three lines. */
  document.getElementById(ta1).addEventListener('keyup', function(event) {
    inputBox1.onkeyup();
    inputBox2.onkeyup();
    inputBox3.onkeyup();
    inputBox4.onkeyup();
  });
  document.getElementById(ta2).addEventListener('keyup', function(event) {
    inputBox1.onkeyup();
    inputBox2.onkeyup();
    inputBox3.onkeyup();
    inputBox4.onkeyup();
  });
  document.getElementById(ta3).addEventListener('keyup', function(event) {
    inputBox1.onkeyup();
    inputBox2.onkeyup();
    inputBox3.onkeyup();
    inputBox4.onkeyup();
  });
  document.getElementById(ta4).addEventListener('keyup', function(event) {
    inputBox1.onkeyup();
    inputBox2.onkeyup();
    inputBox3.onkeyup();
    inputBox4.onkeyup();
  });
    
} /* End of main function */


function tagPreviewCompleteHeart(a, b, c, d, e, f, g, h, i, j, k, l){
  
    
    /* Turning function arguments into variables */
    var ta1 = arguments[0];
    var ta2 = arguments[1];
    var ta3 = arguments[2];
    var ta4 = arguments[3];
    var tline1 = arguments[4];
    var tline2 = arguments[5]
    var tline3 = arguments[6];
    var tline4 = arguments[7];
    var taf1 = arguments[8];
    var taf2 = arguments[9];
    var taf3 = arguments[10];
    var taf4 = arguments[11];
  
    /* Removing event listeners from other functions */  
    document.getElementById(ta1).removeEventListener('keyup', function(event) {
      inputBox1.onkeyup();
      inputBox2.onkeyup();
      inputBox3.onkeyup();
    });
    document.getElementById(ta2).removeEventListener('keyup', function(event) {
      inputBox1.onkeyup();
      inputBox2.onkeyup();
      inputBox3.onkeyup();
    });
    document.getElementById(ta3).removeEventListener('keyup', function(event) {
      inputBox1.onkeyup();
      inputBox2.onkeyup();
      inputBox3.onkeyup();
    });
    document.getElementById(ta1).removeEventListener('keyup', function(event) {
      inputBox1.onkeyup();
      inputBox2.onkeyup();
      inputBox3.onkeyup();
      inputBox4.onkeyup();
    });
    document.getElementById(ta2).removeEventListener('keyup', function(event) {
      inputBox1.onkeyup();
      inputBox2.onkeyup();
      inputBox3.onkeyup();
      inputBox4.onkeyup();
    });
    document.getElementById(ta3).removeEventListener('keyup', function(event) {
      inputBox1.onkeyup();
      inputBox2.onkeyup();
      inputBox3.onkeyup();
      inputBox4.onkeyup();
    });
    document.getElementById(ta4).removeEventListener('keyup', function(event) {
      inputBox1.onkeyup();
      inputBox2.onkeyup();
      inputBox3.onkeyup();
      inputBox4.onkeyup();
    });
    
  /* Set default state of characters remaining text */    
  var tl1 = $('\#' + ta1).val().length;
  var tl2 = $('\#' + ta2).val().length;
  var tl3 = $('\#' + ta2).val().length;
  $('\#' + taf1).html(tl1 + ' / ' + 15);
  $('\#' + taf2).html(tl2 + ' / ' + 15);
  $('\#' + taf3).html(tl3 + ' / ' + 13);

  /* Function to alter characters remaining dynamically - Input 1 */
  $('\#' + ta1).keyup(function() {
    var text_length = $('\#' + ta1).val().length;
    var text_remaining = 15 - text_length;

    $('\#' + taf1).html(text_length + ' / 15');
    if (text_remaining == 0) {
      document.getElementById(taf1).style.color = "#ff0000";
      document.getElementById(taf1).append('  [Legibility concern]');
    } else if (text_remaining == 1) {
      document.getElementById(taf1).style.color = "#ed8326";
    } else {
      document.getElementById(taf1).style.color = "blue";
    }
  });  
  /* Function to alter characters remaining dynamically - Input 2 */
  $('\#' + ta2).keyup(function() {
    var text_length = $('\#' + ta2).val().length;
    var text_remaining = 15 - text_length;

    $('\#' + taf2).html(text_length + ' / 15');
    if (text_remaining == 0) {
      document.getElementById(taf2).style.color = "#ff0000";
      document.getElementById(taf2).append('  [Legibility concern]');
    } else if (text_remaining == 1) {
      document.getElementById(taf2).style.color = "#ed8326";
      document.getElementById(taf2).append('  [Legibility concern]');
    } else {
      document.getElementById(taf2).style.color = "blue";
    }
  });
  /* Function to alter characters remaining dynamically - Input 3 */
  $('\#' + ta3).keyup(function() {
    var text_length = $('\#' + ta3).val().length;
    var text_remaining = 13 - text_length;

    $('\#' + taf3).html(text_length + ' / 13');
    if (text_remaining == 0) {
      document.getElementById(taf3).style.color = "#ff0000";
      document.getElementById(taf3).append('  [Legibility concern]');
    } else if (text_remaining == 1) {
      document.getElementById(taf3).style.color = "#ed8326";
      document.getElementById(taf3).append('  [Legibility concern]');
    } else {
      document.getElementById(taf3).style.color = "blue";
    }
  });
  
    
  /* Variables to be used in character size functions as well as starting values */
  var lineOneSize = 40;
  var lineTwoSize = 40;
  var lineThreeSize = 40;
  var lineFourSize = 40;

  var lineOneCharSpacing = 2;
  var lineTwoCharSpacing = 2;
  var lineThreeCharSpacing = 2;
  var lineFourCharSpacing = 2;

  /* Shortcut variables for input boxes */
  var inputBox1 = document.getElementById(ta1);
  var inputBox2 = document.getElementById(ta2);
  var inputBox3 = document.getElementById(ta3);
  var inputBox4 = document.getElementById(ta4); 
    
  /* Text sizing function for input box 1 */
  inputBox1.onkeyup = function() {
    /* Condition 2: If there are more than 5 characters, change font size */
    if (document.getElementById(ta1).value.length <= 5) {
      lineOneSize = 45;
      lineOneCharSpacing = 2;
    }
    if (document.getElementById(ta1).value.length > 5) {
      lineOneSize = 45;
      lineOneCharSpacing = 1.7;
    }
    if (document.getElementById(ta1).value.length > 6) {
      lineOneSize = 40;
      lineOneCharSpacing = 1.4;
    }
    if (document.getElementById(ta1).value.length > 7) {
      lineOneSize = 34;
      lineOneCharSpacing = 1.1;
    }
    if (document.getElementById(ta1).value.length > 8) {
      lineOneSize = 29;
      lineOneCharSpacing = 0.8;
    }
    if (document.getElementById(ta1).value.length > 9) {
      lineOneSize = 27;
      lineOneCharSpacing = 0.5;
    }
    if (document.getElementById(ta1).value.length > 10) {
      lineOneSize = 24;
      lineOneCharSpacing = 0.2;
    }
    if (document.getElementById(ta1).value.length > 11) {
      lineOneSize = 23;
      lineOneCharSpacing = 0;
    }
    if (document.getElementById(ta1).value.length > 12) {
      lineOneSize = 22;
      lineOneCharSpacing = 0;
    }
    if (document.getElementById(ta1).value.length > 13) {
      lineOneSize = 21;
      lineOneCharSpacing = 0;
    }
    if (document.getElementById(ta1).value.length > 14) {
      lineOneSize = 20;
      lineOneCharSpacing = 0;
    }
    /* Condition 1: if there is text in other lines, change the min size of line 1 */
    var lineNumberMode = 0;
    if (document.getElementById(ta2).value.length >= 1 || document.getElementById(ta3).value.length >= 1) {
      lineNumberMode = 1;
    }
    if (document.getElementById(ta2).value.length >= 1 && (document.getElementById(ta3).value.length >= 1)) {
      lineNumberMode = 2;
    }

    var lineNumberFactor = 1;
    if (lineNumberMode == 0) {
      lineNumberFactor = 1.2;
    }
    if (lineNumberMode == 1) {
      lineNumberFactor = 1.10;
    }
    if (lineNumberMode == 2) {
      lineNumberFactor = 1.05;
    }
    /* Original lineNumberFactors: 1, .9, .7, .55 */
    document.getElementById(tline1).innerHTML = inputBox1.value;
    
    if (lineNumberMode == 2) {
      if (document.getElementById(ta1).value.length > 9 && document.getElementById(ta1).value.length < 14) {
        lineOneSize = 27/lineNumberFactor;
      }
      if (document.getElementById(ta1).value.length > 9 && document.getElementById(ta1).value.length > 13) {
        lineOneSize = 24/lineNumberFactor;
      }
    }
    if (lineNumberMode == 1 && lineOneSize*lineNumberFactor < 24) {
      lineOneSize = 24/lineNumberFactor;
    }
    if (lineOneSize * lineNumberFactor < 23) {
      lineOneSize = 23/lineNumberFactor;
    }
    if (lineNumberMode === 1 && lineOneSize*lineNumberFactor > 46.8)
        {lineOneSize = 46.8/lineNumberFactor;
    }
    if (lineNumberMode === 2 && lineOneSize*lineNumberFactor > 40)
        {lineOneSize = 40/lineNumberFactor;
    }
    document.getElementById(tline1).style.fontSize = lineOneSize * lineNumberFactor + "px";
    document.getElementById(tline1).style.letterSpacing = lineOneCharSpacing + "px";
    var lineOneHeight
    lineOneHeight = (30 / (lineOneSize * lineNumberFactor) * 120)
    if (lineOneHeight > 130) {lineOneHeight = 130}
    if (lineOneHeight < 90) {lineOneHeight = 90}
    document.getElementById(tline1).style.lineHeight = lineOneHeight + "%";
  }

 

  /* Text sizing function for input box 2 */
  inputBox2.onkeyup = function() {
    /* Condition 2: If there are more than 5 characters, change font size */
    if (document.getElementById(ta2).value.length <= 5) {
      lineTwoSize = 45;
      lineTwoCharSpacing = 2;
    }
    if (document.getElementById(ta2).value.length > 5) {
      lineTwoSize = 45;
      lineTwoCharSpacing = 1.7;
    }
    if (document.getElementById(ta2).value.length > 6) {
      lineTwoSize = 40;
      lineTwoCharSpacing = 1.4;
    }
    if (document.getElementById(ta2).value.length > 7) {
      lineTwoSize = 34;
      lineTwoCharSpacing = 1.1;
    }
    if (document.getElementById(ta2).value.length > 8) {
      lineTwoSize = 29;
      lineTwoCharSpacing = 0.8;
    }
    if (document.getElementById(ta2).value.length > 9) {
      lineTwoSize = 27;
      lineTwoCharSpacing = 0.5;
    }
    if (document.getElementById(ta2).value.length > 10) {
      lineTwoSize = 24;
      lineTwoCharSpacing = 0.2;
    }
    if (document.getElementById(ta2).value.length > 11) {
      lineTwoSize = 23;
      lineTwoCharSpacing = 0;
    }
    if (document.getElementById(ta2).value.length > 12) {
      lineTwoSize = 22;
      lineTwoCharSpacing = 0;
    }
    if (document.getElementById(ta2).value.length > 13) {
      lineTwoSize = 21;
      lineTwoCharSpacing = 0;
    }
    if (document.getElementById(ta2).value.length > 14) {
      lineTwoSize = 20;
      lineTwoCharSpacing = 0;
    }
    /* Condition 1: if there is text in other lines, change the min size of line 1 */
    var lineNumberMode = 0;
    if (document.getElementById(ta1).value.length >= 1 || document.getElementById(ta3).value.length >= 1) {
      lineNumberMode = 1;
    }
    if (document.getElementById(ta1).value.length >= 1 && (document.getElementById(ta3).value.length >= 1)) {
      lineNumberMode = 2;
    }
    var lineNumberFactor = 1;
    if (lineNumberMode == 0) {
      lineNumberFactor = 1.2;
    }
    if (lineNumberMode == 1) {
      lineNumberFactor = 1.10;
    }
    if (lineNumberMode == 2) {
      lineNumberFactor = 1.05;
    }
    if (lineNumberMode == 1) {
        if (document.getElementById(ta2).value.length == 7) {
        lineTwoSize = 38;
        lineTwoCharSpacing = 1.3;
      }
    }
    
    document.getElementById(tline2).innerHTML = inputBox2.value;
    inputBox1.onkeyup();
    if (document.getElementById(ta1).value.length >= 1 && lineTwoSize * lineNumberFactor > lineOneSize * lineNumberFactor) {
      lineTwoSize = lineOneSize;
    }
    if (lineTwoSize * lineNumberFactor < 22) {
      lineTwoSize = 22/lineNumberFactor;
    }
    if (lineNumberMode === 1 && lineTwoSize*lineNumberFactor > 46.8)
        {lineTwoSize = 46.8/lineNumberFactor;
    }
    if (lineNumberMode === 2 && lineTwoSize*lineNumberFactor > 40)
        {lineTwoSize = 40/lineNumberFactor;
    }
    document.getElementById(tline2).style.fontSize = lineTwoSize * lineNumberFactor + "px";
    document.getElementById(tline2).style.letterSpacing = lineTwoCharSpacing + "px";
    var lineTwoHeight
    lineTwoHeight = (30 / (lineTwoSize * lineNumberFactor) * 120)
    if (lineTwoHeight > 130) {lineTwoHeight = 130}
    if (lineTwoHeight < 90) {lineTwoHeight = 90}
    document.getElementById(tline2).style.lineHeight = lineTwoHeight + "%";
  }


    
  /* Text sizing function for input box 3 */
  inputBox3.onkeyup = function() {
    /* Condition 2: If there are more than 5 characters, change font size */
    if (document.getElementById(ta3).value.length <= 5) {
      lineThreeSize = 45;
      lineThreeCharSpacing = 2;
    }
    if (document.getElementById(ta3).value.length > 5) {
      lineThreeSize = 45;
      lineThreeCharSpacing = 1.7;
    }
    if (document.getElementById(ta3).value.length > 6) {
      lineThreeSize = 40;
      lineThreeCharSpacing = 1.4;
    }
    if (document.getElementById(ta3).value.length > 7) {
      lineThreeSize = 34;
      lineThreeCharSpacing = 1.1;
    }
    if (document.getElementById(ta3).value.length > 8) {
      lineThreeSize = 29;
      lineThreeCharSpacing = 0.8;
    }
    if (document.getElementById(ta3).value.length > 9) {
      lineThreeSize = 27;
      lineThreeCharSpacing = 0.5;
    }
    if (document.getElementById(ta3).value.length > 10) {
      lineThreeSize = 24;
      lineThreeCharSpacing = 0.2;
    }
    if (document.getElementById(ta3).value.length > 11) {
      lineThreeSize = 23;
      lineThreeCharSpacing = 0.0;
    }
    if (document.getElementById(ta3).value.length > 12) {
      lineThreeSize = 21;
      lineThreeCharSpacing = 0.0;
    }
    if (document.getElementById(ta3).value.length > 13) {
      lineThreeSize = 20;
      lineThreeCharSpacing = 0;
    }
    /* Condition 1: if there is text in other lines, change the min size of line 1 */
    var lineNumberMode = 0;
    if (document.getElementById(ta1).value.length >= 1 || document.getElementById(ta2).value.length >= 1) {
      lineNumberMode = 1;
    }
    if (document.getElementById(ta1).value.length >= 1 && (document.getElementById(ta2).value.length >= 1)) {
      lineNumberMode = 2;
    }
    var lineNumberFactor = 1;
    if (lineNumberMode == 0) {
      lineNumberFactor = 1.2;
    }
    if (lineNumberMode == 1) {
      lineNumberFactor = 1.10;
    }
    if (lineNumberMode == 2) {
      lineNumberFactor = 1.05;
    }
    if (lineNumberMode == 2) {
      if (document.getElementById(ta3).value.length == 8) {
        lineThreeSize = 31;
        lineThreeCharSpacing = 1.0;
      }
      if (document.getElementById(ta3).value.length == 7) {
        lineThreeSize = 34;
        lineThreeCharSpacing = 1.1;  
      }}
    
    document.getElementById(tline3).innerHTML = inputBox3.value;
    inputBox1.onkeyup();
    if (document.getElementById(ta1).value.length >= 1 && lineThreeSize * lineNumberFactor > lineOneSize * lineNumberFactor) {
      lineThreeSize = lineOneSize;
    }
    inputBox2.onkeyup();
    if (document.getElementById(ta2).value.length >= 1 && lineThreeSize * lineNumberFactor > lineTwoSize * lineNumberFactor) {
      lineThreeSize = lineTwoSize;
    }
    if (lineThreeSize * lineNumberFactor < 22) {
      lineThreeSize = 22/lineNumberFactor;
    }
    document.getElementById(tline3).style.fontSize = lineThreeSize * lineNumberFactor + "px";
    document.getElementById(tline3).style.letterSpacing = lineThreeCharSpacing + "px";
    if (document.getElementById(ta2).value.length > 0 && document.getElementById(ta3).value.length > document.getElementById(ta2).value.length) {document.getElementById(tline2).style.fontSize = lineThreeSize * lineNumberFactor + "px";}
    if (document.getElementById(ta2).value.length > 0 && document.getElementById(ta3).value.length > document.getElementById(ta2).value.length) {document.getElementById(tline2).style.letterSpacing = lineThreeCharSpacing + "px";}
    var lineThreeHeight
    lineThreeHeight = (30 / (lineThreeSize * lineNumberFactor) * 120)
    if (lineThreeHeight > 130) {lineThreeHeight = 130}
    if (lineThreeHeight < 90) {lineThreeHeight = 90}
    document.getElementById(tline3).style.lineHeight = lineThreeHeight + "%";
  }


  
  /* Adding event listeners to call all four text sizing functions when a key is pressed in any of the four input boxes. This is necessary as the size of one line is dynamically calculated by the size of the other three lines. */
  document.getElementById(ta1).addEventListener('keyup', function(event) {
    inputBox1.onkeyup();
    inputBox2.onkeyup();
    inputBox3.onkeyup();
  });
  document.getElementById(ta2).addEventListener('keyup', function(event) {
    inputBox1.onkeyup();
    inputBox2.onkeyup();
    inputBox3.onkeyup();
  });
  document.getElementById(ta3).addEventListener('keyup', function(event) {
    inputBox1.onkeyup();
    inputBox2.onkeyup();
    inputBox3.onkeyup();
  });
    
} /* End of main function */



function tagPreviewCompleteSlide(a, b, c, d, e, f, g, h, i, j, k, l){
    
  var text_max = 15;
  /* CHANGE keyup TO keypress IF YOU WANT THE VISUAL AUTO-DELETE TO STOP HAPPENING. DOING SO WILL INTRODUCE ANOTHER ISSUE, WHICH IS THAT YOU CAN NO LONGER TYPE NEW CHARACTERS WHEN ALL CURRENT ONES ARE HIGHLIGHTED */

    /* Turning function arguments into variables */
    var ta1 = arguments[0];
    var ta2 = arguments[1];
    var ta3 = arguments[2];
    var ta4 = arguments[3];
    var tline1 = arguments[4];
    var tline2 = arguments[5]
    var tline3 = arguments[6];
    var tline4 = arguments[7];
    var taf1 = arguments[8];
    var taf2 = arguments[9];
    var taf3 = arguments[10];
    var taf4 = arguments[11];
  
    /* Removing event listeners from other functions */  
    document.getElementById(ta1).removeEventListener('keyup', function(event) {
      inputBox1.onkeyup();
      inputBox2.onkeyup();
      inputBox3.onkeyup();
    });
    document.getElementById(ta2).removeEventListener('keyup', function(event) {
      inputBox1.onkeyup();
      inputBox2.onkeyup();
      inputBox3.onkeyup();
    });
    document.getElementById(ta3).removeEventListener('keyup', function(event) {
      inputBox1.onkeyup();
      inputBox2.onkeyup();
      inputBox3.onkeyup();
    });
    document.getElementById(ta1).removeEventListener('keyup', function(event) {
      inputBox1.onkeyup();
      inputBox2.onkeyup();
      inputBox3.onkeyup();
      inputBox4.onkeyup();
    });
    document.getElementById(ta2).removeEventListener('keyup', function(event) {
      inputBox1.onkeyup();
      inputBox2.onkeyup();
      inputBox3.onkeyup();
      inputBox4.onkeyup();
    });
    document.getElementById(ta3).removeEventListener('keyup', function(event) {
      inputBox1.onkeyup();
      inputBox2.onkeyup();
      inputBox3.onkeyup();
      inputBox4.onkeyup();
    });
    document.getElementById(ta4).removeEventListener('keyup', function(event) {
      inputBox1.onkeyup();
      inputBox2.onkeyup();
      inputBox3.onkeyup();
      inputBox4.onkeyup();
    });
  
  /* Set default state of characters remaining text */
  var tl1 = $('\#' + ta1).val().length;
  var tl2 = $('\#' + ta2).val().length;
  var tl3 = $('\#' + ta2).val().length;
  var tl4 = $('\#' + ta2).val().length;
  $('\#' + taf1).html(tl1 + ' / ' + text_max);
  $('\#' + taf2).html(tl2 + ' / ' + text_max);
  $('\#' + taf3).html(tl3 + ' / ' + text_max);
  $('\#' + taf4).html(tl4 + ' / ' + text_max);

  /* Function to alter characters remaining dynamically - Input 1 */
  $('\#' + ta1).keyup(function() {
    var text_length = $('\#' + ta1).val().length;
    var text_remaining = text_max - text_length;

    $('\#' + taf1).html(text_length + ' / 15');
    if (text_remaining == 0) {
      document.getElementById(taf1).style.color = "#ff0000";
      document.getElementById(taf1).append('  [Legibility concern]');
    } else if (text_remaining == 1 || text_remaining == 2) {
      document.getElementById(taf1).style.color = "#ed8326";
      document.getElementById(taf1).append('  [Legibility concern]');
    } else {
      document.getElementById(taf1).style.color = "blue";
    }
  });  
  /* Function to alter characters remaining dynamically - Input 2 */
  $('\#' + ta2).keyup(function() {
    var text_length = $('\#' + ta2).val().length;
    var text_remaining = text_max - text_length;

    $('\#' + taf2).html(text_length + ' / 15');
    if (text_remaining == 0) {
      document.getElementById(taf2).style.color = "#ff0000";
      document.getElementById(taf2).append('  [Legibility concern]');
    } else if (text_remaining == 1 || text_remaining == 2) {
      document.getElementById(taf2).style.color = "#ed8326";
      document.getElementById(taf2).append('  [Legibility concern]');
    } else {
      document.getElementById(taf2).style.color = "blue";
    }
  });
  /* Function to alter characters remaining dynamically - Input 3 */
  $('\#' + ta3).keyup(function() {
    var text_length = $('\#' + ta3).val().length;
    var text_remaining = text_max - text_length;

    $('\#' + taf3).html(text_length + ' / 15');
    if (text_remaining == 0) {
      document.getElementById(taf3).style.color = "#ff0000";
      document.getElementById(taf3).append('  [Legibility concern]');
    } else if (text_remaining == 1 || text_remaining == 2) {
      document.getElementById(taf3).style.color = "#ed8326";
      document.getElementById(taf3).append('  [Legibility concern]');
    } else {
      document.getElementById(taf3).style.color = "blue";
    }
  });
  /* Function to alter characters remaining dynamically - Input 4 */
  $('\#' + ta4).keyup(function() {
    var text_length = $('\#' + ta4).val().length;
    var text_remaining = text_max - text_length;

    $('\#' + taf4).html(text_length + ' / 15');
    if (text_remaining == 0) {
      document.getElementById(taf4).style.color = "#ff0000";
      document.getElementById(taf4).append('  [Legibility concern]');
    } else if (text_remaining == 1 || text_remaining == 2) {
      document.getElementById(taf4).style.color = "#ed8326";
      document.getElementById(taf4).append('  [Legibility concern]');
    } else {
      document.getElementById(taf4).style.color = "blue";
    }
  });
     
    
  /* Variables to be used in character size functions as well as starting values */
  var lineOneSize = 40;
  var lineTwoSize = 40;
  var lineThreeSize = 40;
  var lineFourSize = 40;

  var lineOneCharSpacing = 2;
  var lineTwoCharSpacing = 2;
  var lineThreeCharSpacing = 2;
  var lineFourCharSpacing = 2;

  /* Shortcut variables for input boxes */
  var inputBox1 = document.getElementById(ta1);
  var inputBox2 = document.getElementById(ta2);
  var inputBox3 = document.getElementById(ta3);
  var inputBox4 = document.getElementById(ta4); 
    
  /* Text sizing function for input box 1 */
  inputBox1.onkeyup = function() {
    /* Condition 2: If there are more than 5 characters, change font size */
    if (document.getElementById(ta1).value.length <= 5) {
      lineOneSize = 40;
      lineOneCharSpacing = 2;
    }
    if (document.getElementById(ta1).value.length > 5) {
      lineOneSize = 40;
      lineOneCharSpacing = 1.6;
    }
    if (document.getElementById(ta1).value.length > 6) {
      lineOneSize = 32.5;
      lineOneCharSpacing = 1.4;
    }
    if (document.getElementById(ta1).value.length > 7) {
      lineOneSize = 30;
      lineOneCharSpacing = 1.2;
    }
    if (document.getElementById(ta1).value.length > 8) {
      lineOneSize = 27.5;
      lineOneCharSpacing = 1;
    }
    if (document.getElementById(ta1).value.length > 9) {
      lineOneSize = 25;
      lineOneCharSpacing = 0.8;
    }
    if (document.getElementById(ta1).value.length > 10) {
      lineOneSize = 23;
      lineOneCharSpacing = 0.6;
    }
    if (document.getElementById(ta1).value.length > 11) {
      lineOneSize = 21;
      lineOneCharSpacing = 0.4;
    }
    if (document.getElementById(ta1).value.length > 12) {
      lineOneSize = 20;
      lineOneCharSpacing = 0.2;
    }
    if (document.getElementById(ta1).value.length > 13) {
      lineOneSize = 19;
      lineOneCharSpacing = 0;
    }
    if (document.getElementById(ta1).value.length > 14) {
      lineOneSize = 18;
      lineOneCharSpacing = 0;
    }
    /* Condition 1: if there is text in other lines, change the min size of line 1 */
    var lineNumberMode = 0;
    if (document.getElementById(ta2).value.length >= 1 || document.getElementById(ta3).value.length >= 1 || document.getElementById(ta4).value.length >= 1) {
      lineNumberMode = 1;
    }
    if (document.getElementById(ta2).value.length >= 1 && (document.getElementById(ta3).value.length >= 1 || document.getElementById(ta4).value.length >= 1)) {
      lineNumberMode = 2;
    }
    if (document.getElementById(ta3).value.length >= 1 && (document.getElementById(ta2).value.length >= 1 || document.getElementById(ta4).value.length >= 1)) {
      lineNumberMode = 2;
    }
    if (document.getElementById(ta3).value.length >= 1 && document.getElementById(ta2).value.length >= 1 && document.getElementById(ta4).value.length >= 1) {
      lineNumberMode = 3;
    }
    var lineNumberFactor = 1;
    if (lineNumberMode == 0) {
      lineNumberFactor = 1;
    }
    if (lineNumberMode == 1) {
      lineNumberFactor = 0.97;
    }
    if (lineNumberMode == 2) {
      lineNumberFactor = 0.94;
    }
    if (lineNumberMode == 3) {
      lineNumberFactor = 0.8;
    }
    /* Original lineNumberFactors: 1, .9, .7, .55 */
    document.getElementById(tline1).innerHTML = inputBox1.value;
    if (lineOneSize * lineNumberFactor < 18) {
      lineOneSize = 18/lineNumberFactor;
    }
    if (lineNumberMode === 1 && lineOneSize*lineNumberFactor > 33)
        {lineOneSize = 33/lineNumberFactor;
    }
    if (lineNumberMode === 2 && lineOneSize*lineNumberFactor > 31)
        {lineOneSize = 31/lineNumberFactor;
    }
    if (lineNumberMode === 3 && lineOneSize*lineNumberFactor > 26)
        {lineOneSize = 26/lineNumberFactor;
    }
    document.getElementById(tline1).style.fontSize = lineOneSize * lineNumberFactor + "px";
    document.getElementById(tline1).style.letterSpacing = lineOneCharSpacing + "px";
    if (lineNumberMode == 1) {document.getElementById(tline1).style.lineHeight = "120%";}
    if (lineNumberMode == 2) {document.getElementById(tline1).style.lineHeight = "105%";}
    if (lineNumberMode == 3) {document.getElementById(tline1).style.lineHeight = "90%";}
  }

 

  /* Text sizing function for input box 2 */
  inputBox2.onkeyup = function() {
    /* Condition 2: If there are more than 5 characters, change font size */
    if (document.getElementById(ta2).value.length <= 5) {
      lineTwoSize = 40;
      lineTwoCharSpacing = 2;
    }
    if (document.getElementById(ta2).value.length > 5) {
      lineTwoSize = 40;
      lineTwoCharSpacing = 1.6;
    }
    if (document.getElementById(ta2).value.length > 6) {
      lineTwoSize = 32.5;
      lineTwoCharSpacing = 1.4;
    }
    if (document.getElementById(ta2).value.length > 7) {
      lineTwoSize = 30;
      lineTwoCharSpacing = 1.2;
    }
    if (document.getElementById(ta2).value.length > 8) {
      lineTwoSize = 27.5;
      lineTwoCharSpacing = 1.0;
    }
    if (document.getElementById(ta2).value.length > 9) {
      lineTwoSize = 25;
      lineTwoCharSpacing = 0.8;
    }
    if (document.getElementById(ta2).value.length > 10) {
      lineTwoSize = 23;
      lineTwoCharSpacing = 0.6;
    }
    if (document.getElementById(ta2).value.length > 11) {
      lineTwoSize = 21;
      lineTwoCharSpacing = 0.4;
    }
    if (document.getElementById(ta2).value.length > 12) {
      lineTwoSize = 20;
      lineTwoCharSpacing = 0.2;
    }
    if (document.getElementById(ta2).value.length > 13) {
      lineTwoSize = 19;
      lineTwoCharSpacing = 0;
    }
    if (document.getElementById(ta2).value.length > 14) {
      lineTwoSize = 18;
      lineTwoCharSpacing = 0;
    }
    /* Condition 1: if there is text in other lines, change the min size of line 1 */
    var lineNumberMode = 0;
    if (document.getElementById(ta1).value.length >= 1 || document.getElementById(ta3).value.length >= 1 || document.getElementById(ta4).value.length >= 1) {
      lineNumberMode = 1;
    }
    if (document.getElementById(ta1).value.length >= 1 && (document.getElementById(ta3).value.length >= 1 || document.getElementById(ta4).value.length >= 1)) {
      lineNumberMode = 2;
    }
    if (document.getElementById(ta3).value.length >= 1 && (document.getElementById(ta1).value.length >= 1 || document.getElementById(ta4).value.length >= 1)) {
      lineNumberMode = 2;
    }
    if (document.getElementById(ta3).value.length >= 1 && document.getElementById(ta1).value.length >= 1 && document.getElementById(ta4).value.length >= 1) {
      lineNumberMode = 3;
    }
    var lineNumberFactor = 1;
    if (lineNumberMode == 0) {
      lineNumberFactor = 1.0;
    }
    if (lineNumberMode == 1) {
      lineNumberFactor = 0.97;
    }
    if (lineNumberMode == 2) {
      lineNumberFactor = 0.94;
    }
    if (lineNumberMode == 3) {
      lineNumberFactor = 0.8;
    }
    document.getElementById(tline2).innerHTML = inputBox2.value;
    inputBox1.onkeyup();
    if (document.getElementById(ta1).value.length >= 1 && lineTwoSize * lineNumberFactor > lineOneSize * lineNumberFactor) {
      lineTwoSize = lineOneSize;
    }
    if (lineTwoSize * lineNumberFactor < 18) {
      lineTwoSize = 18/lineNumberFactor;
    }
    if (lineNumberMode === 1 && lineTwoSize*lineNumberFactor > 33)
        {lineTwoSize = 33/lineNumberFactor;
    }
    if (lineNumberMode === 2 && lineTwoSize*lineNumberFactor > 31)
        {lineTwoSize = 31/lineNumberFactor;
    }
    if (lineNumberMode === 3 && lineTwoSize*lineNumberFactor > 26)
        {lineTwoSize = 26/lineNumberFactor;
    }
    document.getElementById(tline2).style.fontSize = lineTwoSize * lineNumberFactor + "px";
    document.getElementById(tline2).style.letterSpacing = lineTwoCharSpacing + "px";
    if (lineNumberMode == 1) {document.getElementById(tline2).style.lineHeight = "120%";}
    if (lineNumberMode == 2) {document.getElementById(tline2).style.lineHeight = "105%";}
    if (lineNumberMode == 3) {document.getElementById(tline2).style.lineHeight = "90%";}
  }


    
  /* Text sizing function for input box 3 */
  inputBox3.onkeyup = function() {
    /* Condition 2: If there are more than 5 characters, change font size */
    if (document.getElementById(ta3).value.length <= 5) {
      lineThreeSize = 40;
      lineThreeCharSpacing = 2;
    }
    if (document.getElementById(ta3).value.length > 5) {
      lineThreeSize = 40;
      lineThreeCharSpacing = 1.6;
    }
    if (document.getElementById(ta3).value.length > 6) {
      lineThreeSize = 32.5;
      lineThreeCharSpacing = 1.4;
    }
    if (document.getElementById(ta3).value.length > 7) {
      lineThreeSize = 30;
      lineThreeCharSpacing = 1.2;
    }
    if (document.getElementById(ta3).value.length > 8) {
      lineThreeSize = 27.5;
      lineThreeCharSpacing = 1.0;
    }
    if (document.getElementById(ta3).value.length > 9) {
      lineThreeSize = 25;
      lineThreeCharSpacing = 0.8;
    }
    if (document.getElementById(ta3).value.length > 10) {
      lineThreeSize = 23;
      lineThreeCharSpacing = 0.6;
    }
    if (document.getElementById(ta3).value.length > 11) {
      lineThreeSize = 21;
      lineThreeCharSpacing = 0.4;
    }
    if (document.getElementById(ta3).value.length > 12) {
      lineThreeSize = 20;
      lineThreeCharSpacing = 0.2;
    }
    if (document.getElementById(ta3).value.length > 13) {
      lineThreeSize = 19;
      lineThreeCharSpacing = 0;
    }
    if (document.getElementById(ta3).value.length > 14) {
      lineThreeSize = 18;
      lineThreeCharSpacing = 0;
    }
    /* Condition 1: if there is text in other lines, change the min size of line 1 */
    var lineNumberMode = 0;
    if (document.getElementById(ta1).value.length >= 1 || document.getElementById(ta2).value.length >= 1 || document.getElementById(ta4).value.length >= 1) {
      lineNumberMode = 1;
    }
    if (document.getElementById(ta1).value.length >= 1 && (document.getElementById(ta2).value.length >= 1 || document.getElementById(ta4).value.length >= 1)) {
      lineNumberMode = 2;
    }
    if (document.getElementById(ta2).value.length >= 1 && (document.getElementById(ta1).value.length >= 1 || document.getElementById(ta4).value.length >= 1)) {
      lineNumberMode = 2;
    }
    if (document.getElementById(ta1).value.length >= 1 && document.getElementById(ta2).value.length >= 1 && document.getElementById(ta4).value.length >= 1) {
      lineNumberMode = 3;
    }
    var lineNumberFactor = 1;
    if (lineNumberMode == 0) {
      lineNumberFactor = 1.0;
    }
    if (lineNumberMode == 1) {
      lineNumberFactor = 0.97;
    }
    if (lineNumberMode == 2) {
      lineNumberFactor = 0.94;
    }
    if (lineNumberMode == 3) {
      lineNumberFactor = 0.8;
    }
    document.getElementById(tline3).innerHTML = inputBox3.value;
    inputBox1.onkeyup();
    if (document.getElementById(ta1).value.length >= 1 && lineThreeSize * lineNumberFactor > lineOneSize * lineNumberFactor) {
      lineThreeSize = lineOneSize;
    }
    inputBox2.onkeyup();
    if (document.getElementById(ta2).value.length >= 1 && lineThreeSize * lineNumberFactor > lineTwoSize * lineNumberFactor) {
      lineThreeSize = lineTwoSize;
    }
    if (lineThreeSize * lineNumberFactor < 18) {
      lineThreeSize = 18/lineNumberFactor;
    }
    if (lineNumberMode === 1 && lineThreeSize*lineNumberFactor > 33)
        {lineThreeSize = 33/lineNumberFactor;
    }
    if (lineNumberMode === 2 && lineThreeSize*lineNumberFactor > 31)
        {lineThreeSize = 31/lineNumberFactor;
    }
    if (lineNumberMode === 3 && lineThreeSize*lineNumberFactor > 26)
        {lineThreeSize = 26/lineNumberFactor;
    }
    document.getElementById(tline3).style.fontSize = lineThreeSize * lineNumberFactor + "px";
    document.getElementById(tline3).style.letterSpacing = lineThreeCharSpacing + "px";
    if (document.getElementById(ta2).value.length > 0 && document.getElementById(ta3).value.length > document.getElementById(ta2).value.length) {document.getElementById(tline2).style.fontSize = lineThreeSize * lineNumberFactor + "px";}
    if (document.getElementById(ta2).value.length > 0 && document.getElementById(ta3).value.length > document.getElementById(ta2).value.length) {document.getElementById(tline2).style.letterSpacing = lineThreeCharSpacing + "px";}
    if (lineNumberMode == 1) {document.getElementById(tline3).style.lineHeight = "120%";}
    if (lineNumberMode == 2) {document.getElementById(tline3).style.lineHeight = "105%";}
    if (lineNumberMode == 3) {document.getElementById(tline3).style.lineHeight = "90%";}
  }


  /* Text sizing function for input box 4 */
  inputBox4.onkeyup = function() {
    /* Condition 2: If there are more than 5 characters, change font size */
    if (document.getElementById(ta4).value.length <= 5) {
      lineFourSize = 40;
      lineFourCharSpacing = 2;
    }
    if (document.getElementById(ta4).value.length > 5) {
      lineFourSize = 40;
      lineFourCharSpacing = 1.6;
    }
    if (document.getElementById(ta4).value.length > 6) {
      lineFourSize = 32.5;
      lineFourCharSpacing = 1.4;
    }
    if (document.getElementById(ta4).value.length > 7) {
      lineFourSize = 30;
      lineFourCharSpacing = 1.2;
    }
    if (document.getElementById(ta4).value.length > 8) {
      lineFourSize = 27.5;
      lineFourCharSpacing = 1.0;
    }
    if (document.getElementById(ta4).value.length > 9) {
      lineFourSize = 25;
      lineFourCharSpacing = 0.8;
    }
    if (document.getElementById(ta4).value.length > 10) {
      lineFourSize = 23;
      lineFourCharSpacing = 0.6;
    }
    if (document.getElementById(ta4).value.length > 11) {
      lineFourSize = 21;
      lineFourCharSpacing = 0.4;
    }
    if (document.getElementById(ta4).value.length > 12) {
      lineFourSize = 20;
      lineFourCharSpacing = 0.2;
    }
    if (document.getElementById(ta4).value.length > 13) {
      lineFourSize = 19;
      lineFourCharSpacing = 0;
    }
    if (document.getElementById(ta4).value.length > 14) {
      lineFourSize = 18;
      lineFourCharSpacing = 0;
    }
    /* Condition 1: if there is text in other lines, change the min size of line 1 */
    var lineNumberMode = 0;
    if (document.getElementById(ta1).value.length >= 1 || document.getElementById(ta2).value.length >= 1 || document.getElementById(ta3).value.length >= 1) {
      lineNumberMode = 1;
    }
    if (document.getElementById(ta1).value.length >= 1 && (document.getElementById(ta2).value.length >= 1 || document.getElementById(ta3).value.length >= 1)) {
      lineNumberMode = 2;
    }
    if (document.getElementById(ta2).value.length >= 1 && (document.getElementById(ta1).value.length >= 1 || document.getElementById(ta3).value.length >= 1)) {
      lineNumberMode = 2;
    }
    if (document.getElementById(ta1).value.length >= 1 && document.getElementById(ta2).value.length >= 1 && document.getElementById(ta3).value.length >= 1) {
      lineNumberMode = 3;
    }
    var lineNumberFactor = 1;
    if (lineNumberMode == 0) {
      lineNumberFactor = 1.0;
    }
    if (lineNumberMode == 1) {
      lineNumberFactor = 0.97;
    }
    if (lineNumberMode == 2) {
      lineNumberFactor = 0.94;
    }
    if (lineNumberMode == 3) {
      lineNumberFactor = 0.8;
    }
    document.getElementById(tline4).innerHTML = inputBox4.value;
    inputBox1.onkeyup();
    if (document.getElementById(ta1).value.length >= 1 && lineFourSize * lineNumberFactor > lineOneSize * lineNumberFactor) {
      lineFourSize = lineOneSize;
    }
    inputBox2.onkeyup();
    if (document.getElementById(ta2).value.length >= 1 && lineFourSize * lineNumberFactor > lineTwoSize * lineNumberFactor) {
      lineFourSize = lineTwoSize;
    }
    inputBox3.onkeyup();
    if (document.getElementById(ta3).value.length >= 1 && lineFourSize * lineNumberFactor > lineThreeSize * lineNumberFactor) {
      lineFourSize = lineThreeSize;
    }
    if (lineFourSize * lineNumberFactor < 18) {
      lineFourSize = 18/lineNumberFactor;
    }
    if (lineNumberMode === 1 && lineFourSize*lineNumberFactor > 33)
        {lineFourSize = 33/lineNumberFactor;
    }
    if (lineNumberMode === 2 && lineFourSize*lineNumberFactor > 31)
        {lineFourSize = 31/lineNumberFactor;
    }
    if (lineNumberMode === 3 && lineFourSize*lineNumberFactor > 26)
        {lineFourSize = 26/lineNumberFactor;
    }
    document.getElementById(tline4).style.fontSize = lineFourSize * lineNumberFactor + "px";
    document.getElementById(tline4).style.letterSpacing = lineFourCharSpacing + "px";
    if (document.getElementById(ta3).value.length > 0 && document.getElementById(ta4).value.length > document.getElementById(ta3).value.length) {
      	document.getElementById(tline3).style.fontSize = lineFourSize * lineNumberFactor + "px";
        document.getElementById(tline2).style.fontSize = lineFourSize * lineNumberFactor + "px";
    };
    if (document.getElementById(ta3).value.length > 0 && document.getElementById(ta4).value.length > document.getElementById(ta3).value.length) {
        document.getElementById(tline3).style.letterSpacing = lineFourCharSpacing + "px";
        document.getElementById(tline2).style.letterSpacing = lineFourCharSpacing + "px";
    }
    if (lineNumberMode == 1) {document.getElementById(tline4).style.lineHeight = "120%";}
    if (lineNumberMode == 2) {document.getElementById(tline4).style.lineHeight = "105%";}
    if (lineNumberMode == 3) {document.getElementById(tline4).style.lineHeight = "90%";}
  }

  
  /* Adding event listeners to call all four text sizing functions when a key is pressed in any of the four input boxes. This is necessary as the size of one line is dynamically calculated by the size of the other three lines. */
  document.getElementById(ta1).addEventListener('keyup', function(event) {
    inputBox1.onkeyup();
    inputBox2.onkeyup();
    inputBox3.onkeyup();
    inputBox4.onkeyup();
  });
  document.getElementById(ta2).addEventListener('keyup', function(event) {
    inputBox1.onkeyup();
    inputBox2.onkeyup();
    inputBox3.onkeyup();
    inputBox4.onkeyup();
  });
  document.getElementById(ta3).addEventListener('keyup', function(event) {
    inputBox1.onkeyup();
    inputBox2.onkeyup();
    inputBox3.onkeyup();
    inputBox4.onkeyup();
  });
  document.getElementById(ta4).addEventListener('keyup', function(event) {
    inputBox1.onkeyup();
    inputBox2.onkeyup();
    inputBox3.onkeyup();
    inputBox4.onkeyup();
  });
    
} /* End of main function */




/* Main code to check the state of the tag selection box, then make changes to the tag preview accordingly */

function changeTagSelection(){
  var tagselectionopt = $('#product-select-348652525product-tag-template-option-0').val();  
            if (tagselectionopt && tagselectionopt.indexOf("Circle (Red)") !== -1){
            $('.tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_circle_red.png?v=64458176501436557241737749386)');
            $('.tagareatext').css('color','#ffd9d6');
            $('.tagareatext').css('text-shadow','0px 0px 0.5px #ffd9d6');
            document.getElementById('textarea1').setAttribute('maxlength', 14);
			document.getElementById('textarea2').setAttribute('maxlength', 14);
			document.getElementById('textarea3').setAttribute('maxlength', 14);
            document.getElementById('textarea4').setAttribute('maxlength', 14);
			document.getElementById('textarea1b').setAttribute('maxlength', 14);
			document.getElementById('textarea2b').setAttribute('maxlength', 14);
			document.getElementById('textarea3b').setAttribute('maxlength', 14);
            document.getElementById('textarea4b').setAttribute('maxlength', 14);
            document.getElementById('engraving').innerHTML = "";
            tagPreviewCompleteCircle("textarea1","textarea2","textarea3","textarea4","firstline","secondline","thirdline","fourthline","textarea_feedback1","textarea_feedback2","textarea_feedback3","textarea_feedback4");
            tagPreviewCompleteCircle("textarea1b","textarea2b","textarea3b","textarea4b","firstlineb","secondlineb","thirdlineb","fourthlineb","textarea_feedback1b","textarea_feedback2b","textarea_feedback3b","textarea_feedback4b");
            $('.tagareatext').css('width','221px');
            $('.tagareatext').css('left','17px');
            $('.tagareatext').css('top','125px');
            $('.tagarea').css('width','260px');
            $('.tagarea').css('height','300px');
            $('.tagarea').css('margin-top','30px');
            if($(window).width() <= 1199) {$('.tagarea').css('margin-top','2px');}
            if($(window).width() <= 1199) {$('.tagarea').css('margin-bottom','20px');}
            $('.tagarea').css('margin-left','5px');   
            $('.inputsection').css('margin-bottom','0px');
            $('.backsametext').show();
            $('.backsamecheckbox').show();
            $('.backtagmedical').hide();
            if($(window).width() > 1199) {$('#textarealabel4').show();}
            if($(window).width() > 1199) {$('#textarealabel4b').show();}
            $('#textarea4').show();
            $('#textarea4b').show();
            $('#textarea_feedback4').show();
            $('#textarea_feedback4b').show();
            $('#slidetaglabeldiv').hide();
            $('#slidetagtitle').attr("required", false);
            $('#slidetagtitle').removeClass("required");
            $('#textarea4').keyup();
            $('#textarea4b').keyup();
            $('#slidetagsizewarning').hide();
        } else if (tagselectionopt && tagselectionopt.indexOf("Circle (Light Blue)") !== -1){
            $('.tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_circle_blue.png?v=80813780536162514151737749386)');
            $('.tagareatext').css('color','#eff0f7');
            $('.tagareatext').css('text-shadow','0px 0px 0.5px #eff0f7');
            document.getElementById('textarea1').setAttribute('maxlength', 14);
			document.getElementById('textarea2').setAttribute('maxlength', 14);
			document.getElementById('textarea3').setAttribute('maxlength', 14);
            document.getElementById('textarea4').setAttribute('maxlength', 14);
			document.getElementById('textarea1b').setAttribute('maxlength', 14);
			document.getElementById('textarea2b').setAttribute('maxlength', 14);
			document.getElementById('textarea3b').setAttribute('maxlength', 14);
            document.getElementById('textarea4b').setAttribute('maxlength', 14);
            document.getElementById('engraving').innerHTML = "";
            tagPreviewCompleteCircle("textarea1","textarea2","textarea3","textarea4","firstline","secondline","thirdline","fourthline","textarea_feedback1","textarea_feedback2","textarea_feedback3","textarea_feedback4");
            tagPreviewCompleteCircle("textarea1b","textarea2b","textarea3b","textarea4b","firstlineb","secondlineb","thirdlineb","fourthlineb","textarea_feedback1b","textarea_feedback2b","textarea_feedback3b","textarea_feedback4b");
            $('.tagareatext').css('width','221px');
            $('.tagareatext').css('left','17px');
            $('.tagareatext').css('top','125px');
            $('.tagarea').css('width','260px');
            $('.tagarea').css('height','300px');
            $('.tagarea').css('margin-top','30px');
            if($(window).width() <= 1199) {$('.tagarea').css('margin-top','2px');}
            if($(window).width() <= 1199) {$('.tagarea').css('margin-bottom','20px');}
            $('.tagarea').css('margin-left','5px');
            $('.inputsection').css('margin-bottom','0px');
            $('.backsametext').show();
            $('.backsamecheckbox').show();
            $('.backtagmedical').hide();
            if($(window).width() > 1199) {$('#textarealabel4').show();}
            if($(window).width() > 1199) {$('#textarealabel4b').show();}
            $('#textarea4').show();
            $('#textarea4b').show();
            $('#textarea_feedback4').show();
            $('#textarea_feedback4b').show();
            $('#slidetaglabeldiv').hide();
            $('#slidetagtitle').attr("required", false);
            $('#slidetagtitle').removeClass("required");
            $('#textarea4').keyup();
            $('#textarea4b').keyup();
            $('#slidetagsizewarning').hide();  
        } else if (tagselectionopt && tagselectionopt.indexOf("Circle (Light Pink)") !== -1){
            $('.tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_circle_pink.png?v=17492450279842259071737749386)');
            $('.tagareatext').css('color','#f7efef');
            $('.tagareatext').css('text-shadow','0px 0px 0.5px #f7efef');
            document.getElementById('textarea1').setAttribute('maxlength', 14);
			document.getElementById('textarea2').setAttribute('maxlength', 14);
			document.getElementById('textarea3').setAttribute('maxlength', 14);
            document.getElementById('textarea4').setAttribute('maxlength', 14);
			document.getElementById('textarea1b').setAttribute('maxlength', 14);
			document.getElementById('textarea2b').setAttribute('maxlength', 14);
			document.getElementById('textarea3b').setAttribute('maxlength', 14);
            document.getElementById('textarea4b').setAttribute('maxlength', 14);
            document.getElementById('engraving').innerHTML = "";
            tagPreviewCompleteCircle("textarea1","textarea2","textarea3","textarea4","firstline","secondline","thirdline","fourthline","textarea_feedback1","textarea_feedback2","textarea_feedback3","textarea_feedback4");
            tagPreviewCompleteCircle("textarea1b","textarea2b","textarea3b","textarea4b","firstlineb","secondlineb","thirdlineb","fourthlineb","textarea_feedback1b","textarea_feedback2b","textarea_feedback3b","textarea_feedback4b");
            $('.tagareatext').css('width','221px');
            $('.tagareatext').css('left','17px');
            $('.tagareatext').css('top','125px');
            $('.tagarea').css('width','260px');
            $('.tagarea').css('height','300px');
            $('.tagarea').css('margin-top','30px');
            if($(window).width() <= 1199) {$('.tagarea').css('margin-top','2px');}
            if($(window).width() <= 1199) {$('.tagarea').css('margin-bottom','20px');}
            $('.tagarea').css('margin-left','5px');
            $('.inputsection').css('margin-bottom','0px');
            $('.backsametext').show();
            $('.backsamecheckbox').show();
            $('.backtagmedical').hide();
            if($(window).width() > 1199) {$('#textarealabel4').show();}
            if($(window).width() > 1199) {$('#textarealabel4b').show();}
            $('#textarea4').show();
            $('#textarea4b').show();
            $('#textarea_feedback4').show();
            $('#textarea_feedback4b').show();
            $('#slidetaglabeldiv').hide();
            $('#slidetagtitle').attr("required", false);
            $('#slidetagtitle').removeClass("required");
            $('#textarea4').keyup();
            $('#textarea4b').keyup();
            $('#slidetagsizewarning').hide();
        } else if (tagselectionopt && tagselectionopt.indexOf("Medical (Circle)") !== -1){
            $('.tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_circle_medical_front.png?v=158299309337313295881737749386)');
            $('.backtagmedical .tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_circle_medical_back.png?v=38303236412570518151737749386)');
            $('.tagareatext').css('color','#f7efef');
            $('.tagareatext').css('text-shadow','0px 0px 0.5px #f7efef');
            document.getElementById('textarea1').setAttribute('maxlength', 14);
			document.getElementById('textarea2').setAttribute('maxlength', 14);
			document.getElementById('textarea3').setAttribute('maxlength', 14);
            document.getElementById('textarea4').setAttribute('maxlength', 14);
			document.getElementById('textarea1b').setAttribute('maxlength', 14);
			document.getElementById('textarea2b').setAttribute('maxlength', 14);
			document.getElementById('textarea3b').setAttribute('maxlength', 14);
            document.getElementById('textarea4b').setAttribute('maxlength', 14);
            document.getElementById('engraving').innerHTML = "";
            tagPreviewCompleteCircle("textarea1","textarea2","textarea3","textarea4","firstline","secondline","thirdline","fourthline","textarea_feedback1","textarea_feedback2","textarea_feedback3","textarea_feedback4");
            tagPreviewCompleteCircle("textarea1b","textarea2b","textarea3b","textarea4b","firstlineb","secondlineb","thirdlineb","fourthlineb","textarea_feedback1b","textarea_feedback2b","textarea_feedback3b","textarea_feedback4b");
            $('.tagareatext').css('width','221px');
            $('.tagareatext').css('left','17px');
            $('.tagareatext').css('top','125px');
            $('.tagarea').css('width','260px');
            $('.tagarea').css('height','300px');
            $('.tagarea').css('margin-top','30px');
            if($(window).width() <= 1199) {$('.tagarea').css('margin-top','2px');}
            if($(window).width() <= 1199) {$('.tagarea').css('margin-bottom','20px');}
            $('.tagarea').css('margin-left','5px');
            $('.inputsection').css('margin-bottom','0px');
            $('.backsametext').hide();
            $('.backsamecheckbox').hide();
            $('.backtagmedical').show();
            document.getElementById("backsamecheckbox").checked = true;
            if($(window).width() > 1199) {$('#textarealabel4').show();}
            if($(window).width() > 1199) {$('#textarealabel4b').show();}
            $('#textarea4').show();
            $('#textarea4b').show();
            $('#textarea_feedback4').show();
            $('#textarea_feedback4b').show();
            $('#slidetaglabeldiv').hide();
            $('#slidetagtitle').attr("required", false);
            $('#slidetagtitle').removeClass("required");
            $('#textarea4').keyup();
            $('#textarea4b').keyup();
            $('#slidetagsizewarning').hide();
        } else if (tagselectionopt && tagselectionopt.indexOf("Circle (Silver)") !== -1){
            $('.tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_circle_silver.png?v=10448256747599555871737749386)');
            $('.tagareatext').css('color','#5e5e5e');
            $('.tagareatext').css('text-shadow','0px 0px 0.5px #5e5e5e');
            document.getElementById('textarea1').setAttribute('maxlength', 14);
			document.getElementById('textarea2').setAttribute('maxlength', 14);
			document.getElementById('textarea3').setAttribute('maxlength', 14);
            document.getElementById('textarea4').setAttribute('maxlength', 14);
			document.getElementById('textarea1b').setAttribute('maxlength', 14);
			document.getElementById('textarea2b').setAttribute('maxlength', 14);
			document.getElementById('textarea3b').setAttribute('maxlength', 14);
            document.getElementById('textarea4b').setAttribute('maxlength', 14);
            document.getElementById('engraving').innerHTML = "";
            tagPreviewCompleteCircle("textarea1","textarea2","textarea3","textarea4","firstline","secondline","thirdline","fourthline","textarea_feedback1","textarea_feedback2","textarea_feedback3","textarea_feedback4");
            tagPreviewCompleteCircle("textarea1b","textarea2b","textarea3b","textarea4b","firstlineb","secondlineb","thirdlineb","fourthlineb","textarea_feedback1b","textarea_feedback2b","textarea_feedback3b","textarea_feedback4b");
            $('.tagareatext').css('width','221px');
            $('.tagareatext').css('left','17px');
            $('.tagareatext').css('top','125px');
            $('.tagarea').css('width','260px');
            $('.tagarea').css('height','300px');
            $('.tagarea').css('margin-top','30px');
            if($(window).width() <= 1199) {$('.tagarea').css('margin-top','2px');}
            if($(window).width() <= 1199) {$('.tagarea').css('margin-bottom','20px');}
            $('.tagarea').css('margin-left','5px');
            $('.inputsection').css('margin-bottom','0px');
            $('.backsametext').show();
            $('.backsamecheckbox').show();
            $('.backtagmedical').hide();
            if($(window).width() > 1199) {$('#textarealabel4').show();}
            if($(window).width() > 1199) {$('#textarealabel4b').show();}
            $('#textarea4').show();
            $('#textarea4b').show();
            $('#textarea_feedback4').show();
            $('#textarea_feedback4b').show();
            $('#slidetaglabeldiv').hide();
            $('#slidetagtitle').attr("required", false);
            $('#slidetagtitle').removeClass("required");
            $('#textarea4').keyup();
            $('#textarea4b').keyup();
            $('#slidetagsizewarning').hide();
        } else if (tagselectionopt && tagselectionopt.indexOf("Circle (Gold)") !== -1){
            $('.tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_circle_gold.png?v=179585939091238603891737749386)');
            $('.tagareatext').css('color','#60491d');
            $('.tagareatext').css('text-shadow','0px 0px 0.5px #60491d');
			document.getElementById('textarea1').setAttribute('maxlength', 14);
			document.getElementById('textarea2').setAttribute('maxlength', 14);
			document.getElementById('textarea3').setAttribute('maxlength', 14);
            document.getElementById('textarea4').setAttribute('maxlength', 14);
			document.getElementById('textarea1b').setAttribute('maxlength', 14);
			document.getElementById('textarea2b').setAttribute('maxlength', 14);
			document.getElementById('textarea3b').setAttribute('maxlength', 14);
            document.getElementById('textarea4b').setAttribute('maxlength', 14);
            document.getElementById('engraving').innerHTML = "";
            tagPreviewCompleteCircle("textarea1","textarea2","textarea3","textarea4","firstline","secondline","thirdline","fourthline","textarea_feedback1","textarea_feedback2","textarea_feedback3","textarea_feedback4");
            tagPreviewCompleteCircle("textarea1b","textarea2b","textarea3b","textarea4b","firstlineb","secondlineb","thirdlineb","fourthlineb","textarea_feedback1b","textarea_feedback2b","textarea_feedback3b","textarea_feedback4b");
            $('.tagareatext').css('width','221px');
            $('.tagareatext').css('left','17px');
            $('.tagareatext').css('top','125px');
            $('.tagarea').css('width','260px');
            $('.tagarea').css('height','300px');
            $('.tagarea').css('margin-top','30px');
            if($(window).width() <= 1199) {$('.tagarea').css('margin-top','2px');}
            if($(window).width() <= 1199) {$('.tagarea').css('margin-bottom','20px');}
            $('.tagarea').css('margin-left','5px');
            $('.inputsection').css('margin-bottom','0px');
            $('.backsametext').show();
            $('.backsamecheckbox').show();
            $('.backtagmedical').hide();
            if($(window).width() > 1199) {$('#textarealabel4').show();}
            if($(window).width() > 1199) {$('#textarealabel4b').show();}
            $('#textarea4').show();
            $('#textarea4b').show();
            $('#textarea_feedback4').show();
            $('#textarea_feedback4b').show();
            $('#slidetaglabeldiv').hide();
            $('#slidetagtitle').attr("required", false);
            $('#slidetagtitle').removeClass("required");
            $('#textarea4').keyup();
            $('#textarea4b').keyup();
            $('#slidetagsizewarning').hide();
        } else if (tagselectionopt && tagselectionopt.indexOf("Heart (Pink)") !== -1){
            $('.tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_heart_pink_brushed.png?v=39311174758351233901737749386)');
            $('.tagareatext').css('color','#f7efef');
            $('.tagareatext').css('text-shadow','0px 0px 0.5px #f7efef');
            $('.tagareatext').css('width','240px');
            $('.tagareatext').css('left','10px');
            $('.tagareatext').css('top','85px');
            $('.tagarea').css('width','260px');
            $('.tagarea').css('height','300px');
            $('.tagarea').css('margin-top','30px');
            if($(window).width() <= 1199) {$('.tagarea').css('margin-top','2px');}
            if($(window).width() <= 1199) {$('.tagarea').css('margin-bottom','20px');}
            $('.tagarea').css('margin-left','5px');
            $('.inputsection').css('margin-bottom','0px');
			document.getElementById('textarea1').setAttribute('maxlength', 15);
			document.getElementById('textarea2').setAttribute('maxlength', 15);
			document.getElementById('textarea3').setAttribute('maxlength', 13);
			document.getElementById('textarea1b').setAttribute('maxlength', 15);
			document.getElementById('textarea2b').setAttribute('maxlength', 15);
			document.getElementById('textarea3b').setAttribute('maxlength', 13);
            document.getElementById('engraving').innerHTML = "";
            tagPreviewCompleteHeart("textarea1","textarea2","textarea3","textarea4","firstline","secondline","thirdline","fourthline","textarea_feedback1","textarea_feedback2","textarea_feedback3","textarea_feedback4");
            tagPreviewCompleteHeart("textarea1b","textarea2b","textarea3b","textarea4b","firstlineb","secondlineb","thirdlineb","fourthlineb","textarea_feedback1b","textarea_feedback2b","textarea_feedback3b","textarea_feedback4b");
            document.getElementById('textarea4').value = "";
            document.getElementById('fourthline').innerHTML = "";
            document.getElementById('textarea4b').value = "";
            document.getElementById('fourthlineb').innerHTML = "";
            $('.backsametext').show();
            $('.backsamecheckbox').show();
            $('.backtagmedical').hide();
            if($(window).width() > 1199) {$('#textarealabel4').hide();}
            if($(window).width() > 1199) {$('#textarealabel4b').hide();}
            $('#textarea4').hide();
            $('#textarea4b').hide();
            $('#textarea_feedback4').hide();
            $('#textarea_feedback4b').hide();
            $('#slidetaglabeldiv').hide();
            $('#slidetagtitle').attr("required", false);
            $('#slidetagtitle').removeClass("required");
            $('#textarea4').keyup();
            $('#textarea4b').keyup();
            $('#slidetagsizewarning').hide();
        } else if (tagselectionopt && tagselectionopt.indexOf("Heart (Red)") !== -1){
            $('.tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_heart_red_brushed.png?v=129579322996590753761737749386)');
            $('.tagareatext').css('color','#ffd9d6');
            $('.tagareatext').css('text-shadow','0px 0px 0.5px #ffd9d6');
            $('.tagareatext').css('width','240px');
            $('.tagareatext').css('left','10px');
            $('.tagareatext').css('top','85px');
            $('.tagarea').css('width','260px');
            $('.tagarea').css('height','300px');
            $('.tagarea').css('margin-top','30px');
            if($(window).width() <= 1199) {$('.tagarea').css('margin-top','2px');}
            if($(window).width() <= 1199) {$('.tagarea').css('margin-bottom','20px');}
            $('.tagarea').css('margin-left','5px');
            $('.inputsection').css('margin-bottom','0px');
			document.getElementById('textarea1').setAttribute('maxlength', 15);
			document.getElementById('textarea2').setAttribute('maxlength', 15);
			document.getElementById('textarea3').setAttribute('maxlength', 13);
			document.getElementById('textarea1b').setAttribute('maxlength', 15);
			document.getElementById('textarea2b').setAttribute('maxlength', 15);
			document.getElementById('textarea3b').setAttribute('maxlength', 13);
            document.getElementById('engraving').innerHTML = "";
            tagPreviewCompleteHeart("textarea1","textarea2","textarea3","textarea4","firstline","secondline","thirdline","fourthline","textarea_feedback1","textarea_feedback2","textarea_feedback3","textarea_feedback4");
            tagPreviewCompleteHeart("textarea1b","textarea2b","textarea3b","textarea4b","firstlineb","secondlineb","thirdlineb","fourthlineb","textarea_feedback1b","textarea_feedback2b","textarea_feedback3b","textarea_feedback4b");
            document.getElementById('textarea4').value = "";
            document.getElementById('fourthline').innerHTML = "";
            document.getElementById('textarea4b').value = "";
            document.getElementById('fourthlineb').innerHTML = "";
            $('.backsametext').show();
            $('.backsamecheckbox').show();
            $('.backtagmedical').hide();
            if($(window).width() > 1199) {$('#textarealabel4').hide();}
            if($(window).width() > 1199) {$('#textarealabel4b').hide();}
            $('#textarea4').hide();
            $('#textarea4b').hide();
            $('#textarea_feedback4').hide();
            $('#textarea_feedback4b').hide();
            $('#slidetaglabeldiv').hide();
            $('#slidetagtitle').attr("required", false);
            $('#slidetagtitle').removeClass("required");
            $('#textarea4').keyup();
            $('#textarea4b').keyup();
            $('#slidetagsizewarning').hide();
        } else if (tagselectionopt && tagselectionopt.indexOf("Heart (Purple)") !== -1){
            $('.tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_heart_purple_brushed.png?v=183275656873557904061737749386)');
            $('.tagareatext').css('color','#eff0f7');
            $('.tagareatext').css('text-shadow','0px 0px 0.5px #eff0f7');
            $('.tagareatext').css('width','240px');
            $('.tagareatext').css('left','10px');
            $('.tagareatext').css('top','85px');
            $('.tagarea').css('width','260px');
            $('.tagarea').css('height','300px');
            $('.tagarea').css('margin-top','30px');
            if($(window).width() <= 1199) {$('.tagarea').css('margin-top','2px');}
            if($(window).width() <= 1199) {$('.tagarea').css('margin-bottom','20px');}
            $('.tagarea').css('margin-left','5px');
            $('.inputsection').css('margin-bottom','0px');
			document.getElementById('textarea1').setAttribute('maxlength', 15);
			document.getElementById('textarea2').setAttribute('maxlength', 15);
			document.getElementById('textarea3').setAttribute('maxlength', 13);
			document.getElementById('textarea1b').setAttribute('maxlength', 15);
			document.getElementById('textarea2b').setAttribute('maxlength', 15);
			document.getElementById('textarea3b').setAttribute('maxlength', 13);
            document.getElementById('engraving').innerHTML = "";
            tagPreviewCompleteHeart("textarea1","textarea2","textarea3","textarea4","firstline","secondline","thirdline","fourthline","textarea_feedback1","textarea_feedback2","textarea_feedback3","textarea_feedback4");
            tagPreviewCompleteHeart("textarea1b","textarea2b","textarea3b","textarea4b","firstlineb","secondlineb","thirdlineb","fourthlineb","textarea_feedback1b","textarea_feedback2b","textarea_feedback3b","textarea_feedback4b");
            document.getElementById('textarea4').value = "";
            document.getElementById('fourthline').innerHTML = "";
            document.getElementById('textarea4b').value = "";
            document.getElementById('fourthlineb').innerHTML = "";
            $('.backsametext').show();
            $('.backsamecheckbox').show();
            $('.backtagmedical').hide();
            if($(window).width() > 1199) {$('#textarealabel4').hide();}
            if($(window).width() > 1199) {$('#textarealabel4b').hide();}
            $('#textarea4').hide();
            $('#textarea4b').hide();
            $('#textarea_feedback4').hide();
            $('#textarea_feedback4b').hide();
            $('#slidetaglabeldiv').hide();
            $('#slidetagtitle').attr("required", false);
            $('#slidetagtitle').removeClass("required");
            $('#textarea4').keyup();
            $('#textarea4b').keyup();
            $('#slidetagsizewarning').hide();
        } else if (tagselectionopt && tagselectionopt.indexOf("Medical (Heart)") !== -1){
            $('.tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_heart_medical_front.png?v=11264168414015569451737749386)');
            $('.backtagmedical .tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_heart_medical_back.png?v=76808736840970400421737749386)');
            $('.tagareatext').css('color','#eff0f7');
            $('.tagareatext').css('text-shadow','0px 0px 0.5px #eff0f7');
            $('.tagareatext').css('width','240px');
            $('.tagareatext').css('left','10px');
            $('.tagareatext').css('top','85px');
            $('.tagarea').css('width','260px');
            $('.tagarea').css('height','300px');
            $('.tagarea').css('margin-top','30px');
            if($(window).width() <= 1199) {$('.tagarea').css('margin-top','2px');}
            if($(window).width() <= 1199) {$('.tagarea').css('margin-bottom','20px');}
            $('.tagarea').css('margin-left','5px');
            $('.inputsection').css('margin-bottom','0px');
			document.getElementById('textarea1').setAttribute('maxlength', 15);
			document.getElementById('textarea2').setAttribute('maxlength', 15);
			document.getElementById('textarea3').setAttribute('maxlength', 13);
			document.getElementById('textarea1b').setAttribute('maxlength', 15);
			document.getElementById('textarea2b').setAttribute('maxlength', 15);
			document.getElementById('textarea3b').setAttribute('maxlength', 13);
            document.getElementById('engraving').innerHTML = "";
            tagPreviewCompleteHeart("textarea1","textarea2","textarea3","textarea4","firstline","secondline","thirdline","fourthline","textarea_feedback1","textarea_feedback2","textarea_feedback3","textarea_feedback4");
            tagPreviewCompleteHeart("textarea1b","textarea2b","textarea3b","textarea4b","firstlineb","secondlineb","thirdlineb","fourthlineb","textarea_feedback1b","textarea_feedback2b","textarea_feedback3b","textarea_feedback4b");
            document.getElementById('textarea4').value = "";
            document.getElementById('fourthline').innerHTML = "";
            document.getElementById('textarea4b').value = "";
            document.getElementById('fourthlineb').innerHTML = "";
            $('.backsametext').hide();
            $('.backsamecheckbox').hide();
            $('.backtagmedical').show();
            document.getElementById("backsamecheckbox").checked = true;
            if($(window).width() > 1199) {$('#textarealabel4').hide();}
            if($(window).width() > 1199) {$('#textarealabel4b').hide();}
            $('#textarea4').hide();
            $('#textarea4b').hide();
            $('#textarea_feedback4').hide();
            $('#textarea_feedback4b').hide();
            $('#slidetaglabeldiv').hide();
            $('#slidetagtitle').attr("required", false);
            $('#slidetagtitle').removeClass("required");
            $('#textarea4').keyup();
            $('#textarea4b').keyup();
            $('#slidetagsizewarning').hide();
        } else if (tagselectionopt && tagselectionopt.indexOf("Heart (Silver)") !== -1){
            $('.tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_heart_silver.png?v=67276673617053736521737749386)');
            $('.tagareatext').css('color','#5e5e5e');
            $('.tagareatext').css('text-shadow','0px 0px 0.5px #5e5e5e');
            $('.tagareatext').css('width','240px');
            $('.tagareatext').css('left','10px');
            $('.tagareatext').css('top','85px');
            $('.tagarea').css('width','260px');
            $('.tagarea').css('height','300px');
            $('.tagarea').css('margin-top','30px');
            if($(window).width() <= 1199) {$('.tagarea').css('margin-top','2px');}
            if($(window).width() <= 1199) {$('.tagarea').css('margin-bottom','20px');}
            $('.tagarea').css('margin-left','5px');
            $('.inputsection').css('margin-bottom','0px');
			document.getElementById('textarea1').setAttribute('maxlength', 15);
			document.getElementById('textarea2').setAttribute('maxlength', 15);
			document.getElementById('textarea3').setAttribute('maxlength', 13);
			document.getElementById('textarea1b').setAttribute('maxlength', 15);
			document.getElementById('textarea2b').setAttribute('maxlength', 15);
			document.getElementById('textarea3b').setAttribute('maxlength', 13);
            document.getElementById('engraving').innerHTML = "";
            tagPreviewCompleteHeart("textarea1","textarea2","textarea3","textarea4","firstline","secondline","thirdline","fourthline","textarea_feedback1","textarea_feedback2","textarea_feedback3","textarea_feedback4");
            tagPreviewCompleteHeart("textarea1b","textarea2b","textarea3b","textarea4b","firstlineb","secondlineb","thirdlineb","fourthlineb","textarea_feedback1b","textarea_feedback2b","textarea_feedback3b","textarea_feedback4b");
            document.getElementById('textarea4').value = "";
            document.getElementById('fourthline').innerHTML = "";
            document.getElementById('textarea4b').value = "";
            document.getElementById('fourthlineb').innerHTML = "";
            $('.backsametext').show();
            $('.backsamecheckbox').show();
            $('.backtagmedical').hide();
            if($(window).width() > 1199) {$('#textarealabel4').hide();}
            if($(window).width() > 1199) {$('#textarealabel4b').hide();}
            $('#textarea4').hide();
            $('#textarea4b').hide();
            $('#textarea_feedback4').hide();
            $('#textarea_feedback4b').hide();
            $('#slidetaglabeldiv').hide();
            $('#slidetagtitle').attr("required", false);
            $('#slidetagtitle').removeClass("required");
            $('#textarea4').keyup();
            $('#textarea4b').keyup();
            $('#slidetagsizewarning').hide();
        } else if (tagselectionopt && tagselectionopt.indexOf("Heart (Gold)") !== -1){
            $('.tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_heart_gold.png?v=44209129935486007051737749386)');
            $('.tagareatext').css('color','#60491d');
            $('.tagareatext').css('text-shadow','0px 0px 0.5px #60491d');
            $('.tagareatext').css('width','240px');
            $('.tagareatext').css('left','10px');
            $('.tagareatext').css('top','85px');
            $('.tagarea').css('width','260px');
            $('.tagarea').css('height','300px');
            $('.tagarea').css('margin-top','30px');
            if($(window).width() <= 1199) {$('.tagarea').css('margin-top','2px');}
            if($(window).width() <= 1199) {$('.tagarea').css('margin-bottom','20px');}
            $('.tagarea').css('margin-left','5px');
            $('.inputsection').css('margin-bottom','0px');
			document.getElementById('textarea1').setAttribute('maxlength', 15);
			document.getElementById('textarea2').setAttribute('maxlength', 15);
			document.getElementById('textarea3').setAttribute('maxlength', 13);
			document.getElementById('textarea1b').setAttribute('maxlength', 15);
			document.getElementById('textarea2b').setAttribute('maxlength', 15);
			document.getElementById('textarea3b').setAttribute('maxlength', 13);
            document.getElementById('engraving').innerHTML = "";
            tagPreviewCompleteHeart("textarea1","textarea2","textarea3","textarea4","firstline","secondline","thirdline","fourthline","textarea_feedback1","textarea_feedback2","textarea_feedback3","textarea_feedback4");
            tagPreviewCompleteHeart("textarea1b","textarea2b","textarea3b","textarea4b","firstlineb","secondlineb","thirdlineb","fourthlineb","textarea_feedback1b","textarea_feedback2b","textarea_feedback3b","textarea_feedback4b");
            document.getElementById('textarea4').value = "";
            document.getElementById('fourthline').innerHTML = "";
            document.getElementById('textarea4b').value = "";
            document.getElementById('fourthlineb').innerHTML = "";
            $('.backsametext').show();
            $('.backsamecheckbox').show();
            $('.backtagmedical').hide();
            if($(window).width() > 1199) {$('#textarealabel4').hide();}
            if($(window).width() > 1199) {$('#textarealabel4b').hide();}
            $('#textarea4').hide();
            $('#textarea4b').hide();
            $('#textarea_feedback4').hide();
            $('#textarea_feedback4b').hide();
            $('#slidetaglabeldiv').hide();
            $('#slidetagtitle').attr("required", false);
            $('#slidetagtitle').removeClass("required");
            $('#textarea4').keyup();
            $('#textarea4b').keyup();
            $('#slidetagsizewarning').hide();
        } else if (tagselectionopt && tagselectionopt.indexOf("Slide (Silver)") !== -1){
            $('.tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_slide_silver.png?v=25884953230347814791737749386)');
            $('.tagareatext').css('color','#5e5e5e');
            $('.tagareatext').css('text-shadow','0px 0px 0.5px #5e5e5e');
            $('.tagareatext').css('width','240px');
            $('.tagareatext').css('left','28px');
            $('.tagareatext').css('top','23px');
            $('.tagarea').css('width','300px');
            $('.tagarea').css('height','180px');
            $('.tagarea').css('margin-top','0px');
            $('.tagarea').css('margin-left','10px');
            $('.inputsection').css('margin-bottom','0px');
            document.getElementById('textarea1').setAttribute('maxlength', 15);
			document.getElementById('textarea2').setAttribute('maxlength', 15);
			document.getElementById('textarea3').setAttribute('maxlength', 15);
			document.getElementById('textarea4').setAttribute('maxlength', 15);
            document.getElementById('engraving').innerHTML = "";
            tagPreviewCompleteSlide("textarea1","textarea2","textarea3","textarea4","firstline","secondline","thirdline","fourthline","textarea_feedback1","textarea_feedback2","textarea_feedback3","textarea_feedback4");
            $('.backsametext').hide();
            $('.backsamecheckbox').hide();
            $('.backtagmedical').hide();
            if($(window).width() > 1199) {$('#textarealabel4').show();}
            if($(window).width() > 1199) {$('#textarealabel4b').hide();}
            $('#textarea4').show();
            $('#textarea4b').hide();
            $('#textarea_feedback4').show();
            $('#textarea_feedback4b').hide();
            document.getElementById("backsamecheckbox").checked = true;
            $('#slidetaglabeldiv').show();
            $('#slidetagtitle').attr("required", true);
            $('#slidetagtitle').addClass("required");
            $('#textarea4').keyup();
            $('#textarea4b').keyup();
            $('#slidetagsizewarning').show();
        } else if (tagselectionopt && tagselectionopt.indexOf("Slide (Gold)") !== -1){
            $('.tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_slide_gold.png?v=77128759492530190111737749386)');
            $('.tagareatext').css('color','#60491d');
            $('.tagareatext').css('text-shadow','0px 0px 0.5px #60491d');
            $('.tagareatext').css('width','240px');
            $('.tagareatext').css('left','28px');
            $('.tagareatext').css('top','23px');
            $('.tagarea').css('width','300px');
            $('.tagarea').css('height','180px');
            $('.tagarea').css('margin-top','0px');
            $('.tagarea').css('margin-left','10px');
            $('.inputsection').css('margin-bottom','0px');
            document.getElementById('textarea1').setAttribute('maxlength', 15);
			document.getElementById('textarea2').setAttribute('maxlength', 15);
			document.getElementById('textarea3').setAttribute('maxlength', 15);
			document.getElementById('textarea4').setAttribute('maxlength', 15);
            document.getElementById('engraving').innerHTML = "";
            tagPreviewCompleteSlide("textarea1","textarea2","textarea3","textarea4","firstline","secondline","thirdline","fourthline","textarea_feedback1","textarea_feedback2","textarea_feedback3","textarea_feedback4");
            $('.backsametext').hide();
            $('.backsamecheckbox').hide();
            $('.backtagmedical').hide();
            if($(window).width() > 1199) {$('#textarealabel4').show();}
            if($(window).width() > 1199) {$('#textarealabel4b').hide();}
            $('#textarea4').show();
            $('#textarea4b').hide();
            $('#textarea_feedback4').show();
            $('#textarea_feedback4b').hide();
            document.getElementById("backsamecheckbox").checked = true;
            $('#slidetaglabeldiv').show();
            $('#slidetagtitle').attr("required", true);
            $('#slidetagtitle').addClass("required");
            $('#textarea4').keyup();
          	$('#textarea4b').keyup();
            $('#slidetagsizewarning').show();
        }
  }
  




function changeFormattingByTag(){
  var tagselectionopt = $('#product-select-348652525product-tag-template-option-0').val();  
            if (tagselectionopt && tagselectionopt.indexOf("Circle (Red)") !== -1){
              $('.tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_circle_red.png?v=64458176501436557241737749386)');
            $('.tagareatext').css('color','#ffd9d6');
            $('.tagareatext').css('text-shadow','0px 0px 0.5px #ffd9d6');
			$('.tagareatext').css('width','221px');
            $('.tagareatext').css('left','17px');
            $('.tagareatext').css('top','125px');
            $('.tagarea').css('width','260px');
            $('.tagarea').css('height','300px');
            $('.tagarea').css('margin-top','30px');
            if($(window).width() <= 1199) {$('.tagarea').css('margin-top','2px');}
            if($(window).width() <= 1199) {$('.tagarea').css('margin-bottom','20px');}
            $('.tagarea').css('margin-left','5px');   
            $('.inputsection').css('margin-bottom','0px');
            $('.backsametext').show();
            $('.backsamecheckbox').show();
            $('.backtagmedical').hide();
            if($(window).width() > 1199) {$('#textarealabel4').show();}
            if($(window).width() > 1199) {$('#textarealabel4b').show();}
            $('#textarea4').show();
            $('#textarea4b').show();
            $('#textarea_feedback4').show();
            $('#textarea_feedback4b').show();
            $('#slidetaglabeldiv').hide();
            $('#slidetagtitle').attr("required", false);
            $('#slidetagtitle').removeClass("required");
            $('#textarea4').keyup();
            $('#textarea4b').keyup();
            $('#slidetagsizewarning').hide();
        } else if (tagselectionopt && tagselectionopt.indexOf("Circle (Light Blue)") !== -1){
            $('.tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_circle_blue.png?v=80813780536162514151737749386)');
            $('.tagareatext').css('color','#eff0f7');
            $('.tagareatext').css('text-shadow','0px 0px 0.5px #eff0f7');
			$('.tagareatext').css('width','221px');
            $('.tagareatext').css('left','17px');
            $('.tagareatext').css('top','125px');
            $('.tagarea').css('width','260px');
            $('.tagarea').css('height','300px');
            $('.tagarea').css('margin-top','30px');
            if($(window).width() <= 1199) {$('.tagarea').css('margin-top','2px');}
            if($(window).width() <= 1199) {$('.tagarea').css('margin-bottom','20px');}
            $('.tagarea').css('margin-left','5px');
            $('.inputsection').css('margin-bottom','0px');
            $('.backsametext').show();
            $('.backsamecheckbox').show();
            $('.backtagmedical').hide();
            if($(window).width() > 1199) {$('#textarealabel4').show();}
            if($(window).width() > 1199) {$('#textarealabel4b').show();}
            $('#textarea4').show();
            $('#textarea4b').show();
            $('#textarea_feedback4').show();
            $('#textarea_feedback4b').show();
            $('#slidetaglabeldiv').hide();
            $('#slidetagtitle').attr("required", false);
            $('#slidetagtitle').removeClass("required");
            $('#textarea4').keyup();
            $('#textarea4b').keyup();
            $('#slidetagsizewarning').hide();
        } else if (tagselectionopt && tagselectionopt.indexOf("Circle (Light Pink)") !== -1){
            $('.tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_circle_pink.png?v=17492450279842259071737749386)');
            $('.tagareatext').css('color','#f7efef');
            $('.tagareatext').css('text-shadow','0px 0px 0.5px #f7efef');
			$('.tagareatext').css('width','221px');
            $('.tagareatext').css('left','17px');
            $('.tagareatext').css('top','125px');
            $('.tagarea').css('width','260px');
            $('.tagarea').css('height','300px');
            $('.tagarea').css('margin-top','30px');
            if($(window).width() <= 1199) {$('.tagarea').css('margin-top','2px');}
            if($(window).width() <= 1199) {$('.tagarea').css('margin-bottom','20px');}
            $('.tagarea').css('margin-left','5px');
            $('.inputsection').css('margin-bottom','0px');
            $('.backsametext').show();
            $('.backsamecheckbox').show();
            $('.backtagmedical').hide();
            if($(window).width() > 1199) {$('#textarealabel4').show();}
            if($(window).width() > 1199) {$('#textarealabel4b').show();}
            $('#textarea4').show();
            $('#textarea4b').show();
            $('#textarea_feedback4').show();
            $('#textarea_feedback4b').show();
            $('#slidetaglabeldiv').hide();
            $('#slidetagtitle').attr("required", false);
            $('#slidetagtitle').removeClass("required");
            $('#textarea4').keyup();
            $('#textarea4b').keyup();
            $('#slidetagsizewarning').hide();
        } else if (tagselectionopt && tagselectionopt.indexOf("Medical (Circle)") !== -1){
            $('.tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_circle_medical_front.png?v=158299309337313295881737749386)');
            $('.backtagmedical .tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_circle_medical_back.png?v=38303236412570518151737749386)');
            $('.tagareatext').css('color','#f7efef');
            $('.tagareatext').css('text-shadow','0px 0px 0.5px #f7efef');
			$('.tagareatext').css('width','221px');
            $('.tagareatext').css('left','17px');
            $('.tagareatext').css('top','125px');
            $('.tagarea').css('width','260px');
            $('.tagarea').css('height','300px');
            $('.tagarea').css('margin-top','30px');
            if($(window).width() <= 1199) {$('.tagarea').css('margin-top','2px');}
            if($(window).width() <= 1199) {$('.tagarea').css('margin-bottom','20px');}
            $('.tagarea').css('margin-left','5px');
            $('.inputsection').css('margin-bottom','0px');
            $('.backsametext').hide();
            $('.backsamecheckbox').hide();
            $('.backtagmedical').show();
            document.getElementById("backsamecheckbox").checked = true;
            if($(window).width() > 1199) {$('#textarealabel4').show();}
            if($(window).width() > 1199) {$('#textarealabel4b').show();}
            $('#textarea4').show();
            $('#textarea4b').show();
            $('#textarea_feedback4').show();
            $('#textarea_feedback4b').show();
            $('#slidetaglabeldiv').hide();
            $('#slidetagtitle').attr("required", false);
            $('#slidetagtitle').removeClass("required");
            $('#textarea4').keyup();
            $('#textarea4b').keyup();
            $('#slidetagsizewarning').hide();
        } else if (tagselectionopt && tagselectionopt.indexOf("Circle (Silver)") !== -1){
            $('.tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_circle_silver.png?v=10448256747599555871737749386)');
            $('.tagareatext').css('color','#5e5e5e');
            $('.tagareatext').css('text-shadow','0px 0px 0.5px #5e5e5e');
			$('.tagareatext').css('width','221px');
            $('.tagareatext').css('left','17px');
            $('.tagareatext').css('top','125px');
            $('.tagarea').css('width','260px');
            $('.tagarea').css('height','300px');
            $('.tagarea').css('margin-top','30px');
            if($(window).width() <= 1199) {$('.tagarea').css('margin-top','2px');}
            if($(window).width() <= 1199) {$('.tagarea').css('margin-bottom','20px');}
            $('.tagarea').css('margin-left','5px');
            $('.inputsection').css('margin-bottom','0px');
            $('.backsametext').show();
            $('.backsamecheckbox').show();
            $('.backtagmedical').hide();
            if($(window).width() > 1199) {$('#textarealabel4').show();}
            if($(window).width() > 1199) {$('#textarealabel4b').show();}
            $('#textarea4').show();
            $('#textarea4b').show();
            $('#textarea_feedback4').show();
            $('#textarea_feedback4b').show();
            $('#slidetaglabeldiv').hide();
            $('#slidetagtitle').attr("required", false);
            $('#slidetagtitle').removeClass("required");
            $('#textarea4').keyup();
            $('#textarea4b').keyup();
            $('#slidetagsizewarning').hide();
        } else if (tagselectionopt && tagselectionopt.indexOf("Circle (Gold)") !== -1){
            $('.tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_circle_gold.png?v=179585939091238603891737749386)');
            $('.tagareatext').css('color','#60491d');
            $('.tagareatext').css('text-shadow','0px 0px 0.5px #60491d');
			$('.tagareatext').css('width','221px');
            $('.tagareatext').css('left','17px');
            $('.tagareatext').css('top','125px');
            $('.tagarea').css('width','260px');
            $('.tagarea').css('height','300px');
            $('.tagarea').css('margin-top','30px');
            if($(window).width() <= 1199) {$('.tagarea').css('margin-top','2px');}
            if($(window).width() <= 1199) {$('.tagarea').css('margin-bottom','20px');}
            $('.tagarea').css('margin-left','5px');
            $('.inputsection').css('margin-bottom','0px');
            $('.backsametext').show();
            $('.backsamecheckbox').show();
            $('.backtagmedical').hide();
            if($(window).width() > 1199) {$('#textarealabel4').show();}
            if($(window).width() > 1199) {$('#textarealabel4b').show();}
            $('#textarea4').show();
            $('#textarea4b').show();
            $('#textarea_feedback4').show();
            $('#textarea_feedback4b').show();
            $('#slidetaglabeldiv').hide();
            $('#slidetagtitle').attr("required", false);
            $('#slidetagtitle').removeClass("required");
            $('#textarea4').keyup();
            $('#textarea4b').keyup();
            $('#slidetagsizewarning').hide();
        } else if (tagselectionopt && tagselectionopt.indexOf("Heart (Pink)") !== -1){
            $('.tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_heart_pink_brushed.png?v=39311174758351233901737749386)');
            $('.tagareatext').css('color','#f7efef');
            $('.tagareatext').css('text-shadow','0px 0px 0.5px #f7efef');
            $('.tagareatext').css('width','240px');
            $('.tagareatext').css('left','10px');
            $('.tagareatext').css('top','85px');
            $('.tagarea').css('width','260px');
            $('.tagarea').css('height','300px');
            $('.tagarea').css('margin-top','30px');
            if($(window).width() <= 1199) {$('.tagarea').css('margin-top','2px');}
            if($(window).width() <= 1199) {$('.tagarea').css('margin-bottom','20px');}
            $('.tagarea').css('margin-left','5px');
            $('.inputsection').css('margin-bottom','0px');
            $('.backsametext').show();
            $('.backsamecheckbox').show();
            $('.backtagmedical').show();
            $('.backtagmedical').hide();
            if($(window).width() > 1199) {$('#textarealabel4').hide();}
            if($(window).width() > 1199) {$('#textarealabel4b').hide();}
            $('#textarea4').hide();
            $('#textarea4b').hide();
            $('#textarea_feedback4').hide();
            $('#textarea_feedback4b').hide();
            $('#slidetaglabeldiv').hide();
            $('#slidetagtitle').attr("required", false);
            $('#slidetagtitle').removeClass("required");
            $('#textarea4').keyup();
            $('#textarea4b').keyup();
            $('#slidetagsizewarning').hide();
        } else if (tagselectionopt && tagselectionopt.indexOf("Heart (Red)") !== -1){
            $('.tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_heart_red_brushed.png?v=129579322996590753761737749386)');
            $('.tagareatext').css('color','#ffd9d6');
            $('.tagareatext').css('text-shadow','0px 0px 0.5px #ffd9d6');
            $('.tagareatext').css('width','240px');
            $('.tagareatext').css('left','10px');
            $('.tagareatext').css('top','85px');
            $('.tagarea').css('width','260px');
            $('.tagarea').css('height','300px');
            $('.tagarea').css('margin-top','30px');
            if($(window).width() <= 1199) {$('.tagarea').css('margin-top','2px');}
            if($(window).width() <= 1199) {$('.tagarea').css('margin-bottom','20px');}
            $('.tagarea').css('margin-left','5px');
            $('.inputsection').css('margin-bottom','0px');
            $('.backsametext').show();
            $('.backsamecheckbox').show();
            $('.backtagmedical').hide();
            if($(window).width() > 1199) {$('#textarealabel4').hide();}
            if($(window).width() > 1199) {$('#textarealabel4b').hide();}
            $('#textarea4').hide();
            $('#textarea4b').hide();
            $('#textarea_feedback4').hide();
            $('#textarea_feedback4b').hide();
            $('#slidetaglabeldiv').hide();
            $('#slidetagtitle').attr("required", false);
            $('#slidetagtitle').removeClass("required");
            $('#textarea4').keyup();
            $('#textarea4b').keyup();
            $('#slidetagsizewarning').hide();
        } else if (tagselectionopt && tagselectionopt.indexOf("Heart (Purple)") !== -1){
            $('.tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_heart_purple_brushed.png?v=183275656873557904061737749386)');
            $('.tagareatext').css('color','#eff0f7');
            $('.tagareatext').css('text-shadow','0px 0px 0.5px #eff0f7');
            $('.tagareatext').css('width','240px');
            $('.tagareatext').css('left','10px');
            $('.tagareatext').css('top','85px');
            $('.tagarea').css('width','260px');
            $('.tagarea').css('height','300px');
            $('.tagarea').css('margin-top','30px');
            if($(window).width() <= 1199) {$('.tagarea').css('margin-top','2px');}
            if($(window).width() <= 1199) {$('.tagarea').css('margin-bottom','20px');}
            $('.tagarea').css('margin-left','5px');
            $('.inputsection').css('margin-bottom','0px');
            $('.backsametext').show();
            $('.backsamecheckbox').show();
            $('.backtagmedical').hide();
            if($(window).width() > 1199) {$('#textarealabel4').hide();}
            if($(window).width() > 1199) {$('#textarealabel4b').hide();}
            $('#textarea4').hide();
            $('#textarea4b').hide();
            $('#textarea_feedback4').hide();
            $('#textarea_feedback4b').hide();
            $('#slidetaglabeldiv').hide();
            $('#slidetagtitle').attr("required", false);
            $('#slidetagtitle').removeClass("required");
            $('#textarea4').keyup();
            $('#textarea4b').keyup();
            $('#slidetagsizewarning').hide();
        } else if (tagselectionopt && tagselectionopt.indexOf("Medical (Heart)") !== -1){
            $('.tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_heart_medical_front.png?v=11264168414015569451737749386)');
            $('.backtagmedical .tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_heart_medical_back.png?v=76808736840970400421737749386)');
            $('.tagareatext').css('color','#eff0f7');
            $('.tagareatext').css('text-shadow','0px 0px 0.5px #eff0f7');
            $('.tagareatext').css('width','240px');
            $('.tagareatext').css('left','10px');
            $('.tagareatext').css('top','85px');
            $('.tagarea').css('width','260px');
            $('.tagarea').css('height','300px');
            $('.tagarea').css('margin-top','30px');
            if($(window).width() <= 1199) {$('.tagarea').css('margin-top','2px');}
            if($(window).width() <= 1199) {$('.tagarea').css('margin-bottom','20px');}
            $('.tagarea').css('margin-left','5px');
            $('.inputsection').css('margin-bottom','0px');
            $('.backsametext').hide();
            $('.backsamecheckbox').hide();
            $('.backtagmedical').show();
            document.getElementById("backsamecheckbox").checked = true;
            if($(window).width() > 1199) {$('#textarealabel4').hide();}
            if($(window).width() > 1199) {$('#textarealabel4b').hide();}
            $('#textarea4').hide();
            $('#textarea4b').hide();
            $('#textarea_feedback4').hide();
            $('#textarea_feedback4b').hide();
            $('#slidetaglabeldiv').hide();
            $('#slidetagtitle').attr("required", false);
            $('#slidetagtitle').removeClass("required");
            $('#textarea4').keyup();
            $('#textarea4b').keyup();
            $('#slidetagsizewarning').hide();
        } else if (tagselectionopt && tagselectionopt.indexOf("Heart (Silver)") !== -1){
            $('.tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_heart_silver.png?v=67276673617053736521737749386)');
            $('.tagareatext').css('color','#5e5e5e');
            $('.tagareatext').css('text-shadow','0px 0px 0.5px #5e5e5e');
            $('.tagareatext').css('width','240px');
            $('.tagareatext').css('left','10px');
            $('.tagareatext').css('top','85px');
            $('.tagarea').css('width','260px');
            $('.tagarea').css('height','300px');
            $('.tagarea').css('margin-top','30px');
            if($(window).width() <= 1199) {$('.tagarea').css('margin-top','2px');}
            if($(window).width() <= 1199) {$('.tagarea').css('margin-bottom','20px');}
            $('.tagarea').css('margin-left','5px');
            $('.inputsection').css('margin-bottom','0px');
            $('.backsametext').show();
            $('.backsamecheckbox').show();
            $('.backtagmedical').hide();
            if($(window).width() > 1199) {$('#textarealabel4').hide();}
            if($(window).width() > 1199) {$('#textarealabel4b').hide();}
            $('#textarea4').hide();
            $('#textarea4b').hide();
            $('#textarea_feedback4').hide();
            $('#textarea_feedback4b').hide();
            $('#slidetaglabeldiv').hide();
            $('#slidetagtitle').attr("required", false);
            $('#slidetagtitle').removeClass("required");
            $('#textarea4').keyup();
            $('#textarea4b').keyup();
            $('#slidetagsizewarning').hide();
        } else if (tagselectionopt && tagselectionopt.indexOf("Heart (Gold)") !== -1){
            $('.tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_heart_gold.png?v=44209129935486007051737749386)');
            $('.tagareatext').css('color','#60491d');
            $('.tagareatext').css('text-shadow','0px 0px 0.5px #60491d');
            $('.tagareatext').css('width','240px');
            $('.tagareatext').css('left','10px');
            $('.tagareatext').css('top','85px');
            $('.tagarea').css('width','260px');
            $('.tagarea').css('height','300px');
            $('.tagarea').css('margin-top','30px');
            if($(window).width() <= 1199) {$('.tagarea').css('margin-top','2px');}
            if($(window).width() <= 1199) {$('.tagarea').css('margin-bottom','20px');}
            $('.tagarea').css('margin-left','5px');
            $('.inputsection').css('margin-bottom','0px');
            $('.backsametext').show();
            $('.backsamecheckbox').show();
            $('.backtagmedical').hide();
            if($(window).width() > 1199) {$('#textarealabel4').hide();}
            if($(window).width() > 1199) {$('#textarealabel4b').hide();}
            $('#textarea4').hide();
            $('#textarea4b').hide();
            $('#textarea_feedback4').hide();
            $('#textarea_feedback4b').hide();
            $('#slidetaglabeldiv').hide();
            $('#slidetagtitle').attr("required", false);
            $('#slidetagtitle').removeClass("required");
            $('#textarea4').keyup();
            $('#textarea4b').keyup();
            $('#slidetagsizewarning').hide();
        } else if (tagselectionopt && tagselectionopt.indexOf("Slide (Silver)") !== -1){
            $('.tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_slide_silver.png?v=25884953230347814791737749386)');
            $('.tagareatext').css('color','#5e5e5e');
            $('.tagareatext').css('text-shadow','0px 0px 0.5px #5e5e5e');
            $('.tagareatext').css('width','240px');
            $('.tagareatext').css('left','28px');
            $('.tagareatext').css('top','23px');
            $('.tagarea').css('width','300px');
            $('.tagarea').css('height','180px');
            $('.tagarea').css('margin-top','0px');
            $('.tagarea').css('margin-left','10px');
            $('.inputsection').css('margin-bottom','0px');
			$('.backsametext').hide();
            $('.backsamecheckbox').hide();
            $('.backtagmedical').hide();
            if($(window).width() > 1199) {$('#textarealabel4').show();}
            if($(window).width() > 1199) {$('#textarealabel4b').hide();}
            $('#textarea4').show();
            $('#textarea4b').hide();
            $('#textarea_feedback4').show();
            $('#textarea_feedback4b').hide();
            document.getElementById("backsamecheckbox").checked = true;
            $('#slidetaglabeldiv').show();
            $('#slidetagtitle').attr("required", true);
            $('#slidetagtitle').addClass("required");
            $('#textarea4').keyup();
            $('#textarea4b').keyup();
            $('#slidetagsizewarning').show();
        } else if (tagselectionopt && tagselectionopt.indexOf("Slide (Gold)") !== -1){
            $('.tagarea').css('background-image','url(//www.madebycleo.com/cdn/shop/t/102/assets/small_slide_gold.png?v=77128759492530190111737749386)');
            $('.tagareatext').css('color','#60491d');
            $('.tagareatext').css('text-shadow','0px 0px 0.5px #60491d');
            $('.tagareatext').css('width','240px');
            $('.tagareatext').css('left','28px');
            $('.tagareatext').css('top','23px');
            $('.tagarea').css('width','300px');
            $('.tagarea').css('height','180px');
            $('.tagarea').css('margin-top','0px');
            $('.tagarea').css('margin-left','10px');
            $('.inputsection').css('margin-bottom','0px');
			$('.backsametext').hide();
            $('.backsamecheckbox').hide();
            $('.backtagmedical').hide();
            if($(window).width() > 1199) {$('#textarealabel4').show();}
            if($(window).width() > 1199) {$('#textarealabel4b').hide();}
            $('#textarea4').show();
            $('#textarea4b').hide();
            $('#textarea_feedback4').show();
            $('#textarea_feedback4b').hide();
            document.getElementById("backsamecheckbox").checked = true;
            $('#slidetaglabeldiv').show();
            $('#slidetagtitle').attr("required", true);
            $('#slidetagtitle').addClass("required");
            $('#textarea4').keyup();
          	$('#textarea4b').keyup();
            $('#slidetagsizewarning').show();
        }
  }
  

/* Call the changeTagSelection code on page load to check the initial state of the selection box, and also make it get called when changing the selection */

$(document).ready(function(){
  if ($('.product_name').length > 0 && $('.product_name').html().indexOf('Engraved') !== -1) {
    changeTagSelection();
    window.addEventListener("resize", changeFormattingByTag);
    $('#product-select-348652525product-tag-template-option-0').change(function(){
      changeTagSelection();
      summarizeTagCustomization();
  });
  }
});
 


function greyOutBackFields() {
  if (document.getElementById("backblankcheckbox").checked == false) {
    document.getElementById("textarea1b").disabled = false;
    document.getElementById("textarea2b").disabled = false;
    document.getElementById("textarea3b").disabled = false;
    document.getElementById("textarea4b").disabled = false;
    $('.backtag > .tagarea > .tagareatext').css('opacity','1');
    
  } else {
    document.getElementById("textarea1b").disabled = true;
    document.getElementById("textarea2b").disabled = true;
    document.getElementById("textarea3b").disabled = true;
    document.getElementById("textarea4b").disabled = true;
    $('.backtag > .tagarea > .tagareatext').css('opacity','0');
  }
};
 

/* Function to summarize tag customization for cart */


//$('#acceptButton').click(function(){
function summarizeTagCustomization() {
  var tagselectionopt = $('#product-select-348652525product-tag-template-option-0').val();
  var ta1 = document.getElementById('textarea1');
  var ta2 = document.getElementById('textarea2');
  var ta3 = document.getElementById('textarea3');
  var ta4 = document.getElementById('textarea4');
  var ta1b = document.getElementById('textarea1b');
  var ta2b = document.getElementById('textarea2b');
  var ta3b = document.getElementById('textarea3b');
  var ta4b = document.getElementById('textarea4b');


  /* Placeholder variable where all tag info will be inserted */
  var tagsummary = "";
  
  
  if (tagselectionopt.indexOf("Slide (Silver)") !== -1 || tagselectionopt.indexOf("Slide (Gold)") !== -1) {
    tagsummary += "\nCollar: "
    if (document.getElementById('slidetagtitle').value.length >= 1) {
    tagsummary += document.getElementById('slidetagtitle').value;
    } else {
      tagsummary += "Unspecified";
    }
    tagsummary += "\n";
  }

 
  if (tagselectionopt.indexOf("Slide (Silver)") == -1 && tagselectionopt.indexOf("Slide (Gold)") == -1 && (ta1.value.length >= 1 || ta2.value.length >= 1 || ta3.value.length >= 1 || ta4.value.length >= 1 )) {
    tagsummary += "\n(FRONT)\n"
	}	  

  
  if (ta1.value.length >= 1) {
    tagsummary += "Line 1: ";
    tagsummary += ta1.value.toUpperCase();
    tagsummary += "\n";
    document.getElementById("textarea_feedback1").style.opacity = 1;
  }
  if (ta2.value.length >= 1) {
    tagsummary += "Line 2: ";
    tagsummary += ta2.value.toUpperCase();
    tagsummary += "\n";
    document.getElementById("textarea_feedback2").style.opacity = 1;
  }
  if (ta3.value.length >= 1) {
    tagsummary += "Line 3: ";
    tagsummary += ta3.value.toUpperCase();
    tagsummary += "\n";
    document.getElementById("textarea_feedback3").style.opacity = 1;
  }
  if (ta4.value.length >= 1) {
    tagsummary += "Line 4: ";
    tagsummary += ta4.value.toUpperCase();
    tagsummary += "\n";
    document.getElementById("textarea_feedback4").style.opacity = 1;
  }
  
  
  if (tagselectionopt.indexOf("Slide (Silver)") == -1 && tagselectionopt.indexOf("Slide (Gold)") == -1 && tagselectionopt.indexOf("Medical") == -1 && (ta1b.value.length >= 1 || ta2b.value.length >= 1 || ta3b.value.length >= 1 || ta4b.value.length >= 1 ) && document.getElementById("backblankcheckbox").checked == false && document.getElementById("backsamecheckbox").checked == false) {
      tagsummary += "(BACK)\n";

    if (ta1b.value.length >= 1) {
      tagsummary += "Line 1: ";
      tagsummary += ta1b.value.toUpperCase();
      tagsummary += "\n";
      document.getElementById("textarea_feedback1b").style.opacity = 1;
    }
    if (ta2b.value.length >= 1) {
      tagsummary += "Line 2: ";
      tagsummary += ta2b.value.toUpperCase();
      tagsummary += "\n";
      document.getElementById("textarea_feedback2b").style.opacity = 1;
    }
    if (ta3b.value.length >= 1) {
      tagsummary += "Line 3: ";
      tagsummary += ta3b.value.toUpperCase();
      tagsummary += "\n";
      document.getElementById("textarea_feedback3b").style.opacity = 1;
    }
    if (ta4b.value.length >= 1) {
      tagsummary += "Line 4: ";
      tagsummary += ta4b.value.toUpperCase();
      tagsummary += "\n";
      document.getElementById("textarea_feedback4b").style.opacity = 1;
    }
  }
 
  if (tagselectionopt.indexOf("Slide (Silver)") == -1 && tagselectionopt.indexOf("Slide (Gold)") == -1 && tagselectionopt.indexOf("Medical") == -1 && document.getElementById("backsamecheckbox").checked == true) {
      tagsummary += "(BACK)*\n";
  
    if (ta1.value.length >= 1) {
      tagsummary += "Line 1: ";
      tagsummary += ta1.value.toUpperCase();
      tagsummary += "\n"
    }
    if (ta2.value.length >= 1) {
      tagsummary += "Line 2: ";
      tagsummary += ta2.value.toUpperCase();
      tagsummary += "\n"
    }
    if (ta3.value.length >= 1) {
      tagsummary += "Line 3: ";
      tagsummary += ta3.value.toUpperCase();
      tagsummary += "\n"
    }
    if (ta4.value.length >= 1) {
      tagsummary += "Line 4: ";
      tagsummary += ta4.value.toUpperCase();
      tagsummary += "\n"
    }
  }

  if (tagselectionopt.indexOf("Slide (Silver)") == -1 && tagselectionopt.indexOf("Slide (Gold)") == -1 && tagselectionopt.indexOf("Medical") == -1 && (ta1b.value.length < 1 && ta2b.value.length < 1 && ta3b.value.length < 1 && ta4b.value.length < 1 ) && document.getElementById("backsamecheckbox").checked == false && document.getElementById("backblankcheckbox").checked == false) {
    tagsummary += "(BACK)\n";
    tagsummary += "-BLANK-";
    tagsummary += "\n"
  };
    
  if (document.getElementById("backsamecheckbox").checked == false && document.getElementById("backblankcheckbox").checked == true && tagselectionopt.indexOf("Slide (Silver)") == -1 && tagselectionopt.indexOf("Slide (Gold)") == -1 && tagselectionopt.indexOf("Medical") == -1) {
    tagsummary += "(BACK)\n";
    tagsummary += "-BLANK-";
    tagsummary += "\n"
  };
	
  
  tagsummary += "\n";
  
  document.getElementById('engraving').innerHTML = tagsummary;
 
}


/* Call the summarizeTagCustomization function */

if (document.getElementById('textarea1')) {
  document.getElementById('textarea1').addEventListener('keyup', function(event) {
  	summarizeTagCustomization();
  });
};
if (document.getElementById('textarea2')) {
  document.getElementById('textarea2').addEventListener('keyup', function(event) {
    summarizeTagCustomization();
  });
};
if (document.getElementById('textarea3')) {
  document.getElementById('textarea3').addEventListener('keyup', function(event) {
    summarizeTagCustomization();
  });
};
if (document.getElementById('textarea4')) {
  document.getElementById('textarea4').addEventListener('keyup', function(event) {
    summarizeTagCustomization();
  });
};
if (document.getElementById('textarea1b')) {
  document.getElementById('textarea1b').addEventListener('keyup', function(event) {
    summarizeTagCustomization();
  });
};
if (document.getElementById('textarea2b')) {
  document.getElementById('textarea2b').addEventListener('keyup', function(event) {
    summarizeTagCustomization();
  });
};
if (document.getElementById('textarea3b')) {
  document.getElementById('textarea3b').addEventListener('keyup', function(event) {
    summarizeTagCustomization();
  });
};
if (document.getElementById('textarea4b')) {
  document.getElementById('textarea4b').addEventListener('keyup', function(event) {
    summarizeTagCustomization();
  });
};
if (document.getElementById('slidetagtitle')) {
  document.getElementById('slidetagtitle').addEventListener('keyup', function(event) {
    summarizeTagCustomization();
  });
};
if (document.getElementById('backblankcheckbox')) {
  document.getElementById('backblankcheckbox').addEventListener('change', function(event) {
    summarizeTagCustomization();
  });
};
if (document.getElementById('backsamecheckbox')) {
  document.getElementById('backsamecheckbox').addEventListener('change', function(event) {
    summarizeTagCustomization();
  });
};

$('#product-select-348652525product-tag-template-option-0').change(function(){
  summarizeTagCustomization();
});

$('#product-select-348652525product-tag-template-option-0').blur(function(){
  summarizeTagCustomization();
});

$('#product-select-348652525product-tag-template').change(function(){
  summarizeTagCustomization();
});

$('#product-select-348652525product-tag-template').blur(function(){
  summarizeTagCustomization();
});


function summarizeTagCustomizationCheck() {
/* OLD HACKY METHOD, POSSIBLY CAUSING ISSUES ON MAC/DESKTOP
  if (document.getElementById('engraving').innerHTML.length < 32) {
  	summarizeTagCustomization();
  }
*/ 
/* NEWER HACKY METHOD.
  var isIPadPro = /Macintosh/.test(navigator.userAgent) && 'ontouchend' in document;
  var isMac = navigator.platform.toUpperCase().indexOf('MAC') !== -1;
  
  if( ((navigator.userAgent.match(/(iPhone|iPod|iPad|Android)/i)) || isIPadPro || isMac ) && (document.getElementById('engraving').innerHTML.length < 32) ) {
  	summarizeTagCustomization();
 */
  if(document.getElementById('engraving').innerHTML.length < 32) {
  	summarizeTagCustomization();
  }
};